// src/Pages/Shopify.jsx  (Course Landing Page)
// CHANGE 1: Preview Section – "Free Lectures" text color fixed to dark
// CHANGE 2: Course Content – removed play icon from Free label, text changed to "Free Lecture"
// CHANGE 3: Requirements section styled like "What You'll Learn"
// CHANGE 4: Description – rich text support + Show Less no-scroll fix
// CHANGE 5: Video cards sized to match image testimonials (200x390px), slider auto-play muted, full-screen viewer with sound
// CHANGE 6: Enroll Now buttons show "Enroll Now • PKR X • XX% OFF" format
// CHANGE 7: Video likes default to 6690 per video with individual counters
// ─── NEW CHANGE A: Sticky enroll button — premium gradient, shadow, typography, text/color rules
// ─── NEW CHANGE B: Announcement bar — seamless infinite marquee (no jump/pause)
// ─── NEW CHANGE C: Video Reviews — no play overlay, center-video autoplay, pause-on-leave
// ─── FIX 1: Instructor data — reads all fields from backend user object correctly
// ─── FIX 2: Reviews display — reads reviews_list OR reviews array as fallback
// ─── FIX 3: Review submission — auth guard, correct error handling, re-fetch after submit
// ─── FIX 4: Reviews now render reliably as Udemy-style cards regardless of backend field
//            naming, support pagination ("Show more reviews"), and a user may submit as
//            many reviews as they like (no client-side "already reviewed" gate); newly
//            submitted review is appended optimistically so it appears immediately.
// ─── FIX 5: Review text content now always shows — broadened normalizeReview to catch
//            every possible backend field, removed the typeof guard that silently dropped
//            valid reviews arrays, and added a debug-friendly console.warn for empty text.
// ─── FIX 6: Show All Reviews now routes to a dedicated Reviews Page (see
//            src/pages/ReviewsPage.jsx). Hero rating is now a clickable link into that
//            page. "Created by <Instructor>" now smooth-scrolls to the Instructor section
//            instead of navigating away. Course Content free-lecture rows are now fully
//            clickable (not just the badge). Instructor section is redesigned with a
//            large banner image and the long bio/description copy removed.
// ─── FIX 7: normalizeReview, formatNumber, and RatingDistribution are now exported so the
//            dedicated Reviews Page (src/pages/ReviewsPage.jsx) can reuse the exact same
//            review-parsing logic and distribution UI instead of duplicating it.
// ─── FIX 8: Instructor image now displays the FULL uploaded picture, uncropped, inside an
//            edge-to-edge SQUARE frame (aspect-ratio 1 / 1, object-contain, no rounding),
//            instead of the previous cropped 16:6 banner crop.
// ─── UX FIX 9: Removed ellipsis/truncation from course content titles, section titles and
//            the breadcrumb — long text now wraps naturally with consistent spacing instead
//            of being clipped. Free Lecture badge stays top-aligned regardless of how many
//            lines the title wraps to.
// ─── UX FIX 10: Header mobile menu trigger is now a real 3-line hamburger icon (was a
//            rotated chevron that looked like an arrow).
// ─── UX FIX 11: Instructor section rebuilt to a circular photo + stat-grid layout (photo
//            left / stats beside it on desktop, stacked on mobile), with the instructor's
//            bio/description now actually rendered underneath.
// ─── UX FIX 12: Reviews header now reads "★ rating • X ratings". Review cards are equal
//            height (a long review no longer stretches its card — it scrolls internally via
//            "Show more") and are laid out as an arrow-free horizontal swipe/scroll slider.
// ─── NEW CHANGE D: Course + instructor descriptions now run through richTextToHtml() —
//            real HTML from the dashboard's editor renders as-is; plain text with **bold**
//            markers and line breaks is converted into proper <strong>/<p>/<br /> so
//            formatting done in the instructor dashboard always shows correctly here.
// ─── NEW CHANGE E: Instructor section rebuilt to a cleaner, Udemy-style layout — circular
//            photo + name/title on the left, a 2x2 grid of stat cards (Total Rating /
//            Reviews / Students / Courses) lined up beside it, and the instructor's bio now
//            renders as rich text with its own "Show more/less" toggle.
// ─── NEW CHANGE F: Reviews header rating number now uses the standard body font instead of
//            the decorative serif, and a fallback rating (4.8 / 5,676 reviews) with sample
//            Urdu/Roman-Urdu reviews is shown whenever the course has no real reviews yet.
// ─── NEW CHANGE G: "Show All Reviews", both rating links (hero + free preview), and every
//            review card now open a Ratings & Reviews view INSIDE this same page (no route
//            change) — same pattern as the free-lecture preview popup — showing the overall
//            rating, distribution, and full review list.
// ─── NEW CHANGE H: Student testimonials and video reviews are now a 2-column "waterfall"
//            grid (4 items visible: 2 rows × 2 columns) that scrolls continuously downward.
//            Video tiles autoplay muted while scrolling; tapping one opens a plain native
//            video player (default browser controls, sound on) instead of a custom
//            reels-style viewer.
// ─── NEW CHANGE I: First 3 Course Content sections now expand automatically on load (still
//            freely togglable afterward, including those first three).
// ─── UX FIX 13: Instructor name column widened and its font sized so a typical two-word
//            name stays on one line instead of wrapping. Instructor "Show more" button no
//            longer sits under the description's fade-out gradient (that overlay was
//            washing its color out compared to "Show less"). Instructor location line
//            removed.
// ─── NEW CHANGE J: Ratings & Reviews overlay's sticky header now reads "{rating} Total
//            Rating · {count} Reviews" (dynamic, same data as the rest of the page) instead
//            of a static "Ratings & Reviews" label. Background page scroll is now locked
//            while the overlay is open (previously unlocked, which let the overlay's own
//            scroll area and the page behind it fight over scroll on mobile and made the
//            overlay feel like it "hung" partway down).
// ─── NEW CHANGE K: Testimonial and video-review tiles enlarged (~50% taller). Both columns
//            of the waterfall grid now share one animation duration (previously staggered)
//            and an exact per-column loop distance (previously a flat -50%, which drifted by
//            half a gap) so the two columns move in sync with no visible jump at the loop
//            boundary. Added a top/bottom edge fade (CSS mask) so the grid fades out at the
//            edges and stays sharp in the middle. Testimonial images are now clickable and
//            open in a full-size lightbox (reusing the existing, previously-unwired
//            imageSliderOpen state) without affecting the auto-scroll animation.
// ─── NEW CHANGE L: Reviews overlay header now reads "{rating} Rating • {count} Reviews" in
//            the exact same typography (size/weight/color, tabular-nums) as the clickable
//            rating line on the main course page, instead of the page-heading serif style.
// ─── NEW CHANGE M: Both waterfall columns (Testimonials + Video Reviews) are now always
//            built to the exact same length (cycling the item list if the count is odd), so
//            their loop distance is always identical and the two columns can never drift out
//            of sync, regardless of how many items are passed in. Added a real progressive
//            blur at the top/bottom edges (a masked backdrop-filter layer, tapering from full
//            blur at the boundary to none toward the center) layered with the existing
//            opacity fade, so content sharpens in the middle and blurs+fades out completely
//            at the edges instead of a hard cutoff.
// ─── NEW CHANGE N: Header nav (desktop + mobile) now includes "Home" and "Services" links
//            alongside Categories/Instructor/About, so the course page can link straight to
//            HomePage.jsx and ServicesPage.jsx.
// ─── NEW CHANGE O: Reviews/students count shown right below the free-preview thumbnail
//            (and everywhere else displayRatingCount is used on this page) now falls back
//            to a large, stable-per-course number — reviews ~11,800–12,899, students
//            61,001–62,000 — instead of the old flat FALLBACK_REVIEW_COUNT / nothing at
//            all for students. Real backend counts still win whenever a course actually
//            has them.
// ─── NEW CHANGE P: Description's "Show more/less" button is now centered on mobile and
//            left-aligned from sm: up, matching the Instructor description's button exactly
//            (same mx-auto sm:mx-0 pattern).
// ─── NEW CHANGE Q: Instructor stat cards (Total Rating / Reviews / Students / Courses) —
//            the label text no longer forces whitespace-nowrap, which was pushing it past
//            the white card's edge on narrow screens; it now wraps within the card instead,
//            with overflow-hidden on the card as a backstop.
// ─── NEW CHANGE R: Review avatars (both the horizontal review cards and the Ratings &
//            Reviews overlay) no longer show the student's uploaded photo — every review
//            now shows a plain black circle with the student's first initial in white,
//            regardless of whether an avatar URL exists.
// ─── NEW CHANGE S: Video Reviews tiles — the YouTube iframe was relying on `object-cover`,
//            which has no effect on <iframe> (object-fit only works on <img>/<video>), so
//            YouTube's own letterboxing was showing as extra empty space inside each tile.
//            Fixed by oversizing the iframe and centering+cropping it manually, matching
//            how the Student Testimonials image tiles actually fill their space.
// ─── NEW CHANGE T: The waterfall auto-scroll (both Student Testimonials and Video Reviews)
//            now pauses for as long as its lightbox/video modal is open, and resumes the
//            moment it's closed — previously it kept scrolling behind the fullscreen view.
// ─── NEW CHANGE U: Reviews/students are now ADDITIVE, not "real-or-fallback" — every
//            course shows the fallback base number (reviews ~11,800–12,899, students
//            61,001–62,000) no matter what, and any real reviews/enrollments a course
//            actually has are added on top of that base instead of replacing it. Previously
//            a course with even one real review/enrollment would show that small real
//            number instead of the big fallback one.
// ─── NEW CHANGE V: Instructor stat card labels — reverted Reviews/Students/Courses back to
//            whitespace-nowrap (that's how they already fit correctly before NEW CHANGE Q;
//            only "Total Rating" was ever overflowing). NEW CHANGE Q's blanket break-words
//            was fracturing "Students" into "Student"/"s" on two lines. Now only two-word
//            labels (just "Total Rating") are allowed to wrap.
// ─── NEW CHANGE W: Video Reviews' baseDuration now matches Student Testimonials' exactly
//            (28s, was 30s) for full parity between the two waterfall grids.
// ─── NEW CHANGE X: Removed the custom orange in-page loading spinner shown while a course
//            loads — the page now renders nothing during that moment, so only the browser's
//            own default tab/address-bar loading indicator is visible.
// ─── NEW CHANGE Y: Instructor section now reads the media gallery (photos + videos, each
//            with a heading and description) set on the Instructor Dashboard → Profile →
//            Description page, and renders it as a small grid right below the instructor's
//            description — same white-card / cream / orange-accent styling as the rest of
//            this section. Clicking a photo opens it in the existing full-size lightbox;
//            clicking a video opens it in the existing native video modal — both reused
//            as separate instances so they don't interfere with the Student Testimonials /
//            Video Reviews grids elsewhere on the page. Nothing else in the Instructor
//            section was touched.
// ─── NEW CHANGE Z: The Student Testimonials image lightbox and the Video Reviews video
//            modal (and the new Instructor photo/video modals from NEW CHANGE Y) now blur
//            everything behind them — a real backdrop blur layered under the dark overlay
//            — instead of just a flat dark scrim, so the previous content behind the
//            opened photo/video is visibly softened rather than just dimmed.
// ─── NEW CHANGE AA: Replaced NEW CHANGE Y's separate "Photos & Videos" grid with a single
//            ordered rendering of instructor.instructorDescriptionBlocks — paragraphs,
//            photos and videos now render in exactly the order the instructor arranged
//            them on the dashboard (a photo/video can sit right after any paragraph),
//            instead of all text first and all media in a grid at the end. Falls back to
//            the older flat instructorDescription + instructorMedia fields (and, if even
//            those are empty, to the instructor's short bio) for any instructor who
//            hasn't re-saved their profile since this change.
// ─── NEW CHANGE AB: The Instructor section's description now defaults to fully expanded
//            (was collapsed behind "Show more") — the whole paragraph/photo/video block
//            is visible as soon as the page loads, with "Show less" at the bottom to
//            collapse it if someone wants to.
// ─── NEW CHANGE AC: Fixed a leftover useEffect that was silently re-collapsing the
//            Instructor description every time a course loaded, overriding NEW CHANGE AB's
//            default-open state before the page ever rendered.
// ─── NEW CHANGE AD: Instructor stat cards (Total Rating / Reviews / Students / Courses) —
//            on narrower Android phones the label text no longer has any risk of fracturing
//            mid-word ("TO"/"TAL", "RA"/"TING"); it now only ever wraps at a real word space,
//            and the icon stacks above the value/label instead of beside it at the smallest
//            size, freeing up enough width for the label to render cleanly.
// ─── NEW CHANGE AE: A video block from the Instructor Dashboard can now carry more than one
//            video link (added there via "+ Add Another Video"). A block with just one link
//            still renders as the same single video card as before; a block with 2+ links
//            renders as a slider (left/right arrows + dots) under that one shared
//            heading/description. A brand new video block started from the top-level
//            "🎬 Add Video" button is always its own separate card, never merged into another
//            block's slider. The full-screen video modal still pages through every video on
//            the profile, in order, regardless of which block or slide it was opened from.
// ─── NEW CHANGE AF: Instructor video blocks with 2+ links now show every video side by side
//            (no arrows) instead of one-at-a-time, so it's obvious at a glance it's a group of
//            videos. Heading/description alignment, size and bold/italic — set per block on
//            the Instructor Dashboard — now render here exactly as chosen.
// ─── NEW CHANGE AG: Announcement bar no longer has the 🎉 emoji, and its "Save X%" now reads
//            the same real price/originalPrice the rest of the page uses (was reading the
//            unused `discountPrice` field, so it never matched an instructor's actual sale).
// ─── NEW CHANGE AH: Footer rebuilt — logo now comes from Super Admin → Settings (Cloudinary),
//            falling back to the original "Lerni" text wordmark when none is set; added the
//            Motiviam Pvt Ltd address/phone/email; replaced the old 6-column link grid with a
//            3-tab FAQ-style accordion (About / Policies / Contact Us, chevron flips open↔closed);
//            added a newsletter box outside the tabs that posts to the backend.
import React, { useState, useEffect, useLayoutEffect, useMemo, useRef, useCallback } from 'react';
import { useNavigate, useParams, useLocation, useNavigationType } from 'react-router-dom';
import { ChevronDown, Play, Star, Users, Clock, BookOpen, Menu, X, Search, Check, Award, Smartphone, Film, Download, Globe, Shield, ChevronLeft, ChevronRight, MessageCircle, Volume2, ArrowLeft, ArrowRight, Infinity as InfinityIcon, Headphones, HelpCircle, Laptop } from 'lucide-react';
import { useCourses } from '../context/CoursesContext';
import { useAuth } from '../context/AuthContext';
import {
  trackViewContent,
  trackAddToCart,
  setPendingCourse,
} from '../utils/facebookPixel';
import FreeLectureVideoTracker, { FreeLectureIframeTracker } from '../components/FreeLectureVideoTracker';
import { readCachedCourse, loadCourseOnce, readExtrasCache, writeExtrasCache } from '../utils/courseCache';
import { beginProgress } from '../utils/pageProgress';
import { fetchSiteSettings } from '../utils/siteSettings';
import { optimizeImage } from '../utils/imageOptimize';

// ─────────────────────────────────────────────────────────────────────────────
// REVIEW NORMALIZATION — broadened to catch every possible backend shape
// Exported (FIX 7) so ReviewsPage.jsx can reuse identical parsing logic.
// ─────────────────────────────────────────────────────────────────────────────
export function normalizeReview(raw, idx) {
  // Accept anything that is a non-null object
  if (!raw || typeof raw !== 'object') return null;

  // ── Author: try every known field name ──────────────────────────────────
  const author =
    raw.authorName ||
    raw.author ||
    raw.userName ||
    raw.username ||
    raw.studentName ||
    raw.name ||
    raw.fullName ||
    raw.full_name ||
    raw.displayName ||
    raw.display_name ||
    raw.user?.name ||
    raw.user?.username ||
    raw.user?.fullName ||
    raw.student?.name ||
    'Student';

  // ── Review text: try every known field name ──────────────────────────────
  const text =
    raw.text      != null ? String(raw.text)      :
    raw.comment   != null ? String(raw.comment)   :
    raw.content   != null ? String(raw.content)   :
    raw.message   != null ? String(raw.message)   :
    raw.body      != null ? String(raw.body)       :
    raw.review    != null ? String(raw.review)     :
    raw.feedback  != null ? String(raw.feedback)   :
    raw.description != null ? String(raw.description) :
    raw.reviewText != null ? String(raw.reviewText) :
    raw.review_text != null ? String(raw.review_text) :
    raw.commentText != null ? String(raw.commentText) :
    raw.details   != null ? String(raw.details)   :
    raw.note      != null ? String(raw.note)       :
    raw.notes     != null ? String(raw.notes)      :
    '';

  if (!text && process.env.NODE_ENV === 'development') {
    console.warn('[normalizeReview] Could not find review text in object. Keys available:', Object.keys(raw));
  }

  // ── Rating ───────────────────────────────────────────────────────────────
  const rating = Number(
    raw.rating ?? raw.stars ?? raw.score ?? raw.value ?? raw.ratingValue ?? 5
  ) || 5;

  // ── Date ─────────────────────────────────────────────────────────────────
  const dateRaw = raw.date || raw.createdAt || raw.created_at || raw.timestamp || raw.postedAt || raw.posted_at || null;
  let date = null;
  if (dateRaw) {
    const d = new Date(dateRaw);
    date = isNaN(d.getTime()) ? String(dateRaw) : d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  // ── Avatar ───────────────────────────────────────────────────────────────
  const avatar =
    raw.avatar ||
    raw.profileImage ||
    raw.profile_image ||
    raw.userImage ||
    raw.user_image ||
    raw.photo ||
    raw.picture ||
    raw.user?.avatar ||
    raw.user?.profileImage ||
    null;

  // ── Stable key ───────────────────────────────────────────────────────────
  const textSnippet = text.slice(0, 30).replace(/\s+/g, '-');
  const tsSnippet   = dateRaw ? String(dateRaw).slice(0, 24) : String(idx);
  const key = raw._id || raw.id || raw.reviewId || raw.review_id
    || `review-${author}-${textSnippet}-${tsSnippet}`;

  return { key, author, text, rating, date, avatar, userId: raw.userId || raw.user_id || raw.user?._id || null };
}

export function formatNumber(num) {
  if (!num) return '0';
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M';
  if (num >= 1_000)     return (num / 1_000).toFixed(1) + 'K';
  return String(num);
}

// ─────────────────────────────────────────────────────────────────────────────
// STABLE PER-COURSE SOCIAL-PROOF NUMBERS — used only as a fallback when a
// course has no real review/student data yet (same purpose as
// FALLBACK_RATING/FALLBACK_REVIEW_COUNT below, just per-course instead of one
// flat number for every course). The same course always gets the same number
// on every load (deterministic hash of its id), but different courses land
// on different numbers within the requested range.
// ─────────────────────────────────────────────────────────────────────────────
function stableCourseOffset(seed, range) {
  const str = String(seed || 'course');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash % range;
}

// ─────────────────────────────────────────────────────────────────────────────
// RATING DISTRIBUTION — animated 5→1 star progress bars (used on ReviewsPage)
// Exported (FIX 7) so ReviewsPage.jsx can render the exact same distribution UI.
// ─────────────────────────────────────────────────────────────────────────────
export function RatingDistribution({ distribution }) {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setAnimated(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="space-y-3" role="list" aria-label="Rating distribution">
      {distribution.map(({ star, count, percentage }) => (
        <div key={star} role="listitem" className="flex items-center gap-3">
          <span className="flex items-center gap-1 text-sm font-semibold text-[#1a1208] w-10 flex-shrink-0">
            {star}
            <Star size={13} className="text-[#f9c97a]" fill="currentColor" />
          </span>
          <div className="flex-1 h-2.5 md:h-3 rounded-full bg-[#f0ebe3] overflow-hidden">
            <div
              className="h-full rounded-full bg-[#f9c97a] transition-all duration-1000 ease-out"
              style={{ width: animated ? `${percentage}%` : '0%' }}
              aria-hidden="true"
            />
          </div>
          <span className="text-sm text-[#9e9789] w-20 text-right flex-shrink-0">
            {percentage}% ({count})
          </span>
        </div>
      ))}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// RICH TEXT RENDERING — course/instructor descriptions are written with a rich
// text editor in the instructor dashboard. If the saved content already
// contains real HTML tags (from a WYSIWYG editor) it is trusted and rendered
// as-is via .lerni-prose. If it's plain text (e.g. **bold** markers and plain
// line breaks), the same formatting is converted into real HTML so bold text
// and paragraph/line spacing always show correctly here — regardless of how
// the dashboard happened to save it.
// ─────────────────────────────────────────────────────────────────────────────
function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function richTextToHtml(raw) {
  if (!raw) return '';
  const text = String(raw);

  // Already real HTML (from a WYSIWYG editor) — trust it as-is.
  if (/<\/?(p|div|br|ul|ol|li|h[1-6]|strong|b|em|i|u|blockquote|a|span)[\s>]/i.test(text)) {
    return text;
  }

  // Plain text: escape it, then re-introduce the formatting.
  let html = escapeHtml(text.trim());

  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
  html = html.replace(/_(.+?)_/g, '<em>$1</em>');

  html = html
    .split(/\n{2,}/)
    .map((block) => `<p>${block.replace(/\n/g, '<br />')}</p>`)
    .join('');

  return html;
}

// ─────────────────────────────────────────────────────────────────────────────
// INSTRUCTOR DESCRIPTION — LEGACY MIGRATION
// Older accounts (or a course whose instructor hasn't re-saved their profile
// since this update) only have the previous flat `instructorDescription`
// string plus a separate `instructorMedia` array, instead of one ordered
// `instructorDescriptionBlocks` list. This turns the old shape into the new
// one on the fly (text first, then each media item) so nothing disappears
// for instructors who haven't touched their profile yet.
// ─────────────────────────────────────────────────────────────────────────────
function buildLegacyDescriptionBlocks(text, media) {
  const blocks = [];
  if (text) blocks.push({ type: 'text', text });
  (Array.isArray(media) ? media : []).forEach((m) => {
    blocks.push({
      type: m.type === 'video' ? 'video' : 'image',
      heading: m.heading || '',
      description: m.description || '',
      videoUrl: m.videoUrl || '',
      imageUrl: m.imageUrl || '',
    });
  });
  return blocks;
}

// A video block may carry several links (`videoUrls`, added via "+ Add
// Another Video" on the dashboard) or just the older single `videoUrl`
// string — this always returns a plain array of non-empty URLs regardless
// of which shape the block was saved with.
function getBlockVideoUrls(b) {
  if (Array.isArray(b.videoUrls)) return b.videoUrls.filter(Boolean);
  return b.videoUrl ? [b.videoUrl] : [];
}

// Heading/description alignment + size + style set per block on the
// Instructor Dashboard — translated into Tailwind classes here so the course
// page renders exactly what was chosen.
const BLOCK_TEXT_ALIGN_CLASS = { left: 'text-left', center: 'text-center', right: 'text-right' };
const BLOCK_HEADING_SIZE_CLASS = { sm: 'text-xs md:text-sm', base: 'text-sm md:text-base', lg: 'text-base md:text-lg', xl: 'text-lg md:text-xl' };
const BLOCK_DESC_SIZE_CLASS = { sm: 'text-[11px] md:text-xs', base: 'text-xs md:text-sm', lg: 'text-sm md:text-base', xl: 'text-base md:text-lg' };
function blockTextClass(block, kind) {
  const align = BLOCK_TEXT_ALIGN_CLASS[block.textAlign] || BLOCK_TEXT_ALIGN_CLASS.left;
  const size = (kind === 'heading' ? BLOCK_HEADING_SIZE_CLASS : BLOCK_DESC_SIZE_CLASS)[block.textSize] || (kind === 'heading' ? BLOCK_HEADING_SIZE_CLASS.base : BLOCK_DESC_SIZE_CLASS.base);
  const weight = kind === 'heading' ? (block.textBold === false ? 'font-normal' : 'font-bold') : (block.textBold ? 'font-bold' : '');
  const italic = block.textItalic ? 'italic' : '';
  return [align, size, weight, italic].filter(Boolean).join(' ');
}

// ─────────────────────────────────────────────────────────────────────────────
// FALLBACK REVIEW DATA — shown only when the course has no real reviews yet.
// Real fetched/submitted reviews always take priority; this is placeholder
// content for this digital marketing & e-commerce course so the page never
// looks empty while real reviews are still coming in.
// ─────────────────────────────────────────────────────────────────────────────
const FALLBACK_RATING = 4.8;
const FALLBACK_REVIEW_COUNT = 5676;
const FALLBACK_RATING_DISTRIBUTION = [
  { star: 5, count: 4427, percentage: 78 },
  { star: 4, count: 851,  percentage: 15 },
  { star: 3, count: 227,  percentage: 4 },
  { star: 2, count: 114,  percentage: 2 },
  { star: 1, count: 57,   percentage: 1 },
];
const FALLBACK_REVIEWS = [
  { key: 'fb-1', author: 'Ayesha Siddiqui', rating: 5, date: 'Aug 12, 2026', avatar: null,
    text: "Yeh course mera business dekhne ka tareeqa hi badal gaya. Facebook Ads aur Shopify wali videos bohat practical thi. Highly recommended for beginners!" },
  { key: 'fb-2', author: 'Muhammad Bilal', rating: 4, date: 'Aug 3, 2026', avatar: null,
    text: "Content is solid, especially the e-commerce dropshipping module. Kuch sections thori lambi lagti hain lekin overall bohat value hai." },
  { key: 'fb-3', author: 'Zainab Fatima', rating: 5, date: 'Jul 27, 2026', avatar: null,
    text: "Sir ne har concept itni acchi tarhan explain kiya keh mujhe apna Instagram store shuru karne ka confidence mil gaya. Best marketing course in Urdu!" },
  { key: 'fb-4', author: 'Usman Tariq', rating: 5, date: 'Jul 19, 2026', avatar: null,
    text: "I run a small clothing brand and this course helped me set up my first proper ad campaign. Roman Urdu explanation makes everything very easy to follow." },
  { key: 'fb-5', author: 'Hina Rafiq', rating: 4, date: 'Jul 10, 2026', avatar: null,
    text: "SEO wala section thora aur detailed ho sakta tha, but overall the course is amazing for e-commerce beginners." },
  { key: 'fb-6', author: 'Ahmed Raza', rating: 5, date: 'Jun 30, 2026', avatar: null,
    text: "Bohat zabardast course hai! Google Ads aur email marketing dono clearly samajh aa gaye. Worth every rupee." },
  { key: 'fb-7', author: 'Sana Malik', rating: 5, date: 'Jun 22, 2026', avatar: null,
    text: "Great mix of theory and hands-on practice. Mujhe apni Daraz store ki sales double karne mein madad mili." },
  { key: 'fb-8', author: 'Fahad Iqbal', rating: 4, date: 'Jun 15, 2026', avatar: null,
    text: "Acha course hai, beginners ke liye perfect starting point digital marketing seekhne ka." },
];

function computeRatingDistribution(reviews) {
  const total = reviews.length || 1;
  return [5, 4, 3, 2, 1].map((star) => {
    const count = reviews.filter((r) => Math.round(r.rating) === star).length;
    return { star, count, percentage: Math.round((count / total) * 100) };
  });
}

// ── YouTube embed helper ───────────────────────────────────────────────────
// NEW: replaces plain `document.body.style.overflow = 'hidden'` for locking
// background scroll while a modal/overlay is open. Used by every modal in
// this file (Free Lecture Preview, image/video lightboxes, reviews
// overlay). Plain overflow:hidden is well known to behave inconsistently
// on iOS Safari specifically — the page can still rubber-band/scroll behind
// the modal, and unlocking it can cause a jarring repaint/jump right at
// that moment. That's what was showing up as "the announcement bar hangs
// after closing the preview, but only on iPhone, not Android" — Android
// Chrome doesn't have this quirk, so the same code looked fine there. This
// is the standard fix: pin the body with position:fixed (recording the
// scroll position first) instead, then restore the exact scroll position
// on unlock.
// FIX: this pair used to be NOT balanced. Every modal below called
// unlockBodyScroll() from an effect cleanup even on runs where it had never
// locked anything (e.g. the effect run from BEFORE the modal opened) — and
// with no lock active, the old unlock read scrollLockY as "0" and ran
// window.scrollTo(0, 0). That is what threw the visitor to the very TOP of
// the page: when opening the free-lecture form (the "jerk"), when opening
// Show All Reviews, and when closing the testimonial image / video-review
// modals ("the ✕ takes me back to the top"). Now it's reference-counted and
// only restores a position it actually saved, instantly (behavior "instant",
// so a site-wide `scroll-behavior: smooth` can't turn the restore into a
// visible scroll-down-from-the-top).
let bodyScrollLockCount = 0;
function lockBodyScroll() {
  bodyScrollLockCount += 1;
  if (bodyScrollLockCount > 1) return; // already pinned by another overlay
  const scrollY = window.scrollY;
  document.body.dataset.scrollLockY = String(scrollY);
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}
function unlockBodyScroll() {
  if (bodyScrollLockCount === 0) return; // nothing was locked — do NOT touch scroll
  bodyScrollLockCount -= 1;
  if (bodyScrollLockCount > 0) return; // another overlay still needs the page pinned
  const scrollY = parseInt(document.body.dataset.scrollLockY || '0', 10);
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  delete document.body.dataset.scrollLockY;
  window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
}

// ─────────────────────────────────────────────────────────────────────────────
// NEW: FREE LECTURE PREVIEW GATE — a visitor's first click on any free
// preview (the hero thumbnail, a "Free Lecture" row, etc.) asks for
// Name/Email/WhatsApp once (posted to /api/preview-leads, which upserts a
// Contact and fires the "form_submitted" automation trigger scoped to
// "form-1-step-1"), then remembers it in this browser for 360 days via
// localStorage — the same persistence pattern already used sitewide for the
// cached logo URLs, just with an expiry attached. Once remembered, every
// future preview on this device opens immediately with no form, and
// EnrolledPage.jsx (the real enrollment page) reads the SAME stored lead to
// skip straight to Step 2, pre-filled.
// ─────────────────────────────────────────────────────────────────────────────
const PREVIEW_LEAD_KEY = 'lerni_preview_lead_v1';
const PREVIEW_LEAD_MAX_AGE_DAYS = 360;

// The customer is remembered in TWO places at once — a real first-party
// cookie (360 days) AND localStorage — and either one is enough to recognise
// them. A cookie survives some "clear site data" / storage-eviction cases
// that wipe localStorage (and the other way round), so having both makes the
// memory much harder to lose. Whichever is found first is copied back into the
// other, so they heal each other. EnrolledPage.jsx has an identical copy of
// these helpers — keep the two in sync.
function readLeadCookie() {
  try {
    const m = document.cookie.match(new RegExp('(?:^|; )' + PREVIEW_LEAD_KEY + '=([^;]*)'));
    return m ? JSON.parse(decodeURIComponent(m[1])) : null;
  } catch { return null; }
}
function writeLeadCookie(data) {
  try {
    const remainingSeconds = Math.max(60, Math.round(((data.savedAt + PREVIEW_LEAD_MAX_AGE_DAYS * 86400000) - Date.now()) / 1000));
    document.cookie = `${PREVIEW_LEAD_KEY}=${encodeURIComponent(JSON.stringify(data))}; max-age=${remainingSeconds}; path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
  } catch { /* cookies blocked — localStorage still has it */ }
}
function isValidLead(d) {
  if (!d || !d.savedAt || !d.name || !d.email || !d.whatsapp) return false;
  return (Date.now() - d.savedAt) / 86400000 <= PREVIEW_LEAD_MAX_AGE_DAYS;
}
function getPreviewLead() {
  let fromStorage = null;
  try { const raw = localStorage.getItem(PREVIEW_LEAD_KEY); if (raw) fromStorage = JSON.parse(raw); } catch { fromStorage = null; }
  const fromCookie = readLeadCookie();
  const found = [fromStorage, fromCookie].filter(isValidLead).sort((a, b) => b.savedAt - a.savedAt)[0] || null;
  if (found) {
    if (!isValidLead(fromStorage)) { try { localStorage.setItem(PREVIEW_LEAD_KEY, JSON.stringify(found)); } catch { /* ignore */ } }
    if (!isValidLead(fromCookie)) writeLeadCookie(found);
  }
  return found;
}
function savePreviewLead({ name, email, whatsapp }) {
  const data = { name, email, whatsapp, savedAt: Date.now() };
  try { localStorage.setItem(PREVIEW_LEAD_KEY, JSON.stringify(data)); } catch { /* storage unavailable — the cookie below still remembers */ }
  writeLeadCookie(data);
}

// Small gate modal — Name/Email/WhatsApp only (no password; that's only
// ever needed at real enrollment, in EnrolledPage.jsx's own Step 1/2).
function PreviewLeadGateModal({ isOpen, onClose, onSuccess, courseId, courseTitle, api, user }) {
  const [form, setForm] = useState({ name: '', email: '', whatsapp: '' });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [isOpen]);

  // A logged-in student already has a name and email on their account.
  useEffect(() => {
    if (isOpen && user) setForm((f) => ({ ...f, name: f.name || user.name || '', email: f.email || user.email || '' }));
  }, [isOpen, user]);

  if (!isOpen) return null;

  function validate() {
    const e = {};
    if (!form.name.trim()) e.name = 'Full name is required.';
    if (!form.email.trim()) e.email = 'Email is required.';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) e.email = 'Enter a valid email address.';
    if (!form.whatsapp.trim()) e.whatsapp = 'WhatsApp number is required.';
    else if (!/^[+\d][\d\s-]{7,14}$/.test(form.whatsapp.trim())) e.whatsapp = 'Enter a valid WhatsApp number, e.g. 03XX-XXXXXXX.';
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  async function handleSubmit() {
    if (!validate()) return;
    setSubmitting(true);
    try {
      await api.post('/course-basic-leads', {
        name: form.name.trim(), email: form.email.trim(), whatsapp: form.whatsapp.trim(),
        courseId: courseId || '', courseTitle: courseTitle || '', source: 'free_preview',
      });
      savePreviewLead({ name: form.name.trim(), email: form.email.trim(), whatsapp: form.whatsapp.trim() });
      onSuccess();
    } catch (err) {
      setErrors({ submit: err?.response?.data?.message || 'Something went wrong. Please try again.' });
      setSubmitting(false);
    }
  }

  return (
    <div className="fixed inset-0 bg-black/30 z-[10000] flex items-center justify-center p-4" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <div className="bg-white rounded-2xl w-full max-w-md p-5 sm:p-6 md:p-7 relative">
        <button onClick={onClose} aria-label="Close" className="absolute top-4 right-4 text-[#9e9789] hover:text-[#1a1208] bg-transparent border-none cursor-pointer">
          <X size={20} />
        </button>
        <h3 className="text-lg md:text-xl font-bold text-[#1a1208] mb-1 pr-6">
          Quick details to unlock your free lectures
        </h3>
        <p className="text-sm text-[#9e9789] mb-5">Fill the basic form to watch the free lectures.</p>
        <div className="space-y-3">
          <div>
            <input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="Full Name"
              className={`w-full border rounded-xl px-4 py-2.5 text-base text-[#1a1208] outline-none transition ${errors.name ? 'border-red-400' : 'border-[#ece6dd] focus:border-[#e8540a]'}`} />
            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
          </div>
          <div>
            <input value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} placeholder="Email Address" type="email"
              className={`w-full border rounded-xl px-4 py-2.5 text-base text-[#1a1208] outline-none transition ${errors.email ? 'border-red-400' : 'border-[#ece6dd] focus:border-[#e8540a]'}`} />
            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
          </div>
          <div>
            <input value={form.whatsapp} onChange={(e) => setForm((f) => ({ ...f, whatsapp: e.target.value }))} placeholder="WhatsApp Number (03XX-XXXXXXX)"
              className={`w-full border rounded-xl px-4 py-2.5 text-base text-[#1a1208] outline-none transition ${errors.whatsapp ? 'border-red-400' : 'border-[#ece6dd] focus:border-[#e8540a]'}`} />
            {errors.whatsapp && <p className="text-red-500 text-xs mt-1">{errors.whatsapp}</p>}
          </div>
          {errors.submit && <p className="text-red-500 text-xs">{errors.submit}</p>}
          <button onClick={handleSubmit} disabled={submitting}
            className="w-full bg-[#e8540a] hover:bg-[#c94708] disabled:opacity-60 disabled:cursor-not-allowed text-white font-bold py-3 rounded-xl transition text-base border-none cursor-pointer mt-2">
            {submitting ? 'Please wait…' : 'Watch Free Lectures'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// BUNDLE OFFER CARD — one premium card per bundle (Course Editor → Bundles):
// dark header with the site's own footer logo, the bundle's name and a short
// description, a dynamic "Complete Guide to N Courses" line (N = number of
// modules), two rows of trust badges, a "What's Included" module list (each
// with the icon/logo the instructor uploaded, a title, a short line, and its
// own original price struck through), a "Best Value" price panel (original
// price vs. the bundle's offer price, with the % and amount saved), and a
// two-tone Enroll button. All the prices and the description come from what
// the instructor typed in the Course Editor.
// ─────────────────────────────────────────────────────────────────────────────
function StruckPrice({ amount, large = false }) {
  return (
    <span
      className={`whitespace-nowrap ${large ? 'text-xl md:text-2xl font-extrabold text-[#6b5e4e]' : 'text-sm md:text-base font-bold text-[#9e9789]'}`}
      style={{ textDecoration: 'line-through', textDecorationColor: '#e8540a', textDecorationThickness: large ? '3px' : '2px' }}
    >
      PKR {Number(amount || 0).toLocaleString()}
    </span>
  );
}

// A trust badge used in the two rows under the bundle title — icon in a
// translucent circle, label underneath, same style for both rows.
function BundleBadge({ Icon, label }) {
  return (
    <div className="flex items-center gap-2.5 min-w-0">
      <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
        <Icon size={17} className="text-[#f9c97a]" />
      </div>
      <span className="text-xs md:text-sm font-semibold text-[#e8d9c5] leading-snug">{label}</span>
    </div>
  );
}

// One "What's Included" row — the instructor's uploaded icon/logo (or an
// orange initial-letter badge when there isn't one yet), the module's title
// and short line, and its own original price struck through on the right.
function BundleModuleRow({ item }) {
  const price = Number(item.price) || 0;
  return (
    <div className="flex items-center gap-3 md:gap-4 rounded-xl border border-[#ece6dd] bg-[#fbf8f3] px-3.5 py-3 md:px-4 md:py-3.5">
      <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-[#ece6dd] flex items-center justify-center flex-shrink-0 overflow-hidden shadow-sm">
        {item.imageUrl ? (
          <img src={optimizeImage(item.imageUrl, 120)} alt={item.title} className="w-full h-full object-cover" loading="lazy" decoding="async" />
        ) : (
          <span className="text-[#e8540a] font-extrabold text-base">{(item.title || '?').charAt(0).toUpperCase()}</span>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm md:text-base font-extrabold text-[#1a1208] uppercase tracking-wide leading-snug break-words">{item.title}</p>
        {item.content && <p className="text-xs md:text-sm text-[#8a7d6c] leading-snug mt-0.5 break-words">{item.content}</p>}
      </div>
      {price > 0 && <div className="flex-shrink-0"><StruckPrice amount={price} /></div>}
    </div>
  );
}

function BundleOfferCard({ bundle, footerLogoUrl, onEnroll }) {
  const items = Array.isArray(bundle.items) ? bundle.items.filter((it) => it && String(it.title || '').trim()) : [];
  const offerPrice = Number(bundle.price) || 0;
  const actualTotal = items.reduce((sum, it) => sum + (Number(it.price) || 0), 0);
  const hasActual = actualTotal > 0 && actualTotal > offerPrice;
  // % off comes from the real numbers whenever the modules have prices;
  // otherwise falls back to the manual "Discount %" typed in the editor.
  const pct = hasActual ? Math.round((1 - offerPrice / actualTotal) * 100) : (Number(bundle.discountPercentage) || 0);
  const saved = hasActual ? actualTotal - offerPrice : 0;
  const courseCount = items.length;

  return (
    <div className="rounded-3xl overflow-hidden border border-[#ece6dd] bg-white shadow-lg flex flex-col">
      {/* HEADER */}
      <div className="relative bg-gradient-to-br from-[#1a1208] via-[#2d2416] to-[#3d2b1a] px-5 md:px-8 pt-6 md:pt-8 pb-6 md:pb-7">
        <div className="relative flex items-start justify-between gap-3 mb-4">
          <span className="inline-flex items-center gap-1.5 bg-[#f9c97a] text-[#7a4a00] text-[11px] font-extrabold tracking-wider uppercase px-3 py-1.5 rounded-full">
            <Award size={13} /> Bundle Offer
          </span>
          {footerLogoUrl && (
            <img src={optimizeImage(footerLogoUrl, 300)} alt="Logo" className="h-8 md:h-9 w-auto object-contain flex-shrink-0" decoding="async" />
          )}
        </div>
        <h3 className="relative text-2xl md:text-3xl font-bold text-white leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>{bundle.name}</h3>
        {courseCount > 0 && (
          <p className="relative mt-1.5 text-sm md:text-base text-[#f9c97a] font-semibold">
            Complete Guide • {courseCount} {courseCount === 1 ? 'Course' : 'Courses'} • One Powerful Bundle
          </p>
        )}
        {bundle.description && (
          <p className="relative mt-3 text-[#d9cfbf] text-sm md:text-base leading-relaxed whitespace-pre-line">{bundle.description}</p>
        )}

        {/* Trust badges — ALL five in one grid (not two grids with a different
            column count stacked on each other, which left their edges
            misaligned row to row) so every badge lines up cleanly. */}
        <div className="relative mt-5 md:mt-6 grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-4 pt-5 border-t border-white/10">
          <BundleBadge Icon={InfinityIcon} label="Lifetime Access" />
          <BundleBadge Icon={Award} label="Certificate of Completion" />
          <BundleBadge Icon={Laptop} label="Learn at Your Own Pace" />
          <BundleBadge Icon={Headphones} label="24/7 Support" />
          <BundleBadge Icon={HelpCircle} label="Live Q&A Sessions" />
        </div>
      </div>

      {/* BODY */}
      <div className="px-4 md:px-8 py-5 md:py-7 flex-1 flex flex-col">
        {items.length > 0 && (
          <>
            <div className="mb-3">
              <p className="text-sm md:text-base font-extrabold uppercase tracking-wide text-[#1a1208]">What's Included</p>
              <span className="block w-10 h-1 rounded-full bg-[#e8540a] mt-1.5" aria-hidden="true" />
            </div>
            <div className="space-y-2.5">
              {items.map((item, i) => <BundleModuleRow key={item._id || i} item={item} />)}
            </div>
          </>
        )}

        {/* PRICE PANEL — "Best Value" ribbon + original vs. offer price. The
            soft blurred colour blobs behind the content are what give this
            panel visible shading/depth (like the reference image) instead of
            one flat gradient. */}
        <div className="relative mt-5 rounded-2xl bg-[#fdf2ea] border border-[#f5ddc4] overflow-hidden">
          <div className="absolute -left-6 -bottom-8 w-32 h-32 rounded-full bg-[#f9c97a]/40 blur-2xl pointer-events-none" aria-hidden="true" />
          <div className="absolute -right-8 -top-10 w-40 h-40 rounded-full bg-[#e8540a]/20 blur-2xl pointer-events-none" aria-hidden="true" />
          <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[#f5ddc4]/60 pointer-events-none" aria-hidden="true" />
          {pct > 0 && (
            <span className="absolute top-0 left-0 inline-flex items-center gap-1 bg-[#e8540a] text-white text-[11px] font-extrabold uppercase tracking-wide px-3 py-1.5 rounded-br-xl z-10">
              <Star size={11} fill="currentColor" /> Best Value
            </span>
          )}
          <div className={`relative grid ${hasActual ? 'grid-cols-2' : 'grid-cols-1'} gap-3 px-4 md:px-6 pt-9 pb-5 md:pt-10`}>
            {hasActual && (
              <div className="text-center border-r border-[#f0dcc2] pr-2">
                <p className="text-[11px] md:text-xs font-bold uppercase tracking-wide text-[#9e9789] mb-1.5">Original Price</p>
                <StruckPrice amount={actualTotal} large />
              </div>
            )}
            <div className="text-center">
              <p className="text-[11px] md:text-xs font-extrabold uppercase tracking-[0.12em] text-[#e8540a] mb-1.5">Bundle Offer Price</p>
              <p className="text-2xl md:text-3xl font-extrabold text-[#1a1208]">PKR {offerPrice.toLocaleString()}</p>
              {/* Sits right under Bundle Offer Price specifically — this column is
                  on the right when there's an Original Price to compare against,
                  matching the reference image (was centered under the whole
                  panel before, which put it under neither column). */}
              {pct > 0 && (
                <span className="inline-flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 bg-[#e8540a] text-white text-xs md:text-sm font-bold px-3.5 py-1.5 rounded-full shadow-sm mt-3">
                  <Award size={13} /> Save {pct}%{saved > 0 ? ` • You save PKR ${saved.toLocaleString()}` : ''}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* ENROLL — two-tone: dark action + orange % badge. The orange section's
            LEFT edge is cut on a slant (not a straight vertical line) via
            clip-path, matching the reference image, instead of the two
            colours just meeting in a straight line down the middle. */}
        <button
          onClick={onEnroll}
          style={{ WebkitTapHighlightColor: 'transparent' }}
          className="relative w-full mt-5 rounded-xl overflow-hidden border-none cursor-pointer shadow-lg text-white font-bold text-sm md:text-base bg-gradient-to-br from-[#1a1208] via-[#2d2416] to-[#3d2b1a] hover:from-[#2d2416] hover:to-[#4a3421] transition"
        >
          <span className={`relative z-10 flex items-center justify-center gap-2 py-3.5 pl-4 ${pct > 0 ? 'pr-20 md:pr-24' : 'pr-4'}`}>
            <ArrowRight size={17} /> Enroll Now in Discounted Price
          </span>
          {pct > 0 && (
            <span
              className="absolute inset-y-0 right-0 z-10 flex items-center justify-center bg-[#e8540a] px-5 md:px-6"
              style={{ clipPath: 'polygon(22px 0, 100% 0, 100% 100%, 0 100%)' }}
            >
              {pct}% OFF
            </span>
          )}
        </button>
      </div>
    </div>
  );
}

// NEW: one collapsible FAQ row — used by the FAQ list an instructor can add
// to any Custom Content Block (Course Editor → Custom Content Blocks).
function FaqAccordionItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-[#ece6dd] rounded-lg bg-white overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 px-3.5 py-3 text-left bg-transparent border-none cursor-pointer"
      >
        <span className="text-sm md:text-base font-semibold text-[#1a1208]">{question}</span>
        <ChevronDown size={16} className={`text-[#9e9789] flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && answer && <p className="px-3.5 pb-3.5 text-sm md:text-base text-[#6b5e4e] leading-relaxed whitespace-pre-line">{answer}</p>}
    </div>
  );
}

function getYouTubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/watch\?v=|\/shorts\/))([^&?/\s]{11})/);
  return m ? m[1] : null;
}

function isBunnyUrl(url) {
  return url && (
    url.includes('bunny.net') ||
    url.includes('vod-cdn.bunny.net') ||
    url.includes('iframe.mediadelivery.net') ||
    url.includes('player.mediadelivery.net') ||
    url.includes('video.bunnycdn.com') ||
    url.includes('b-cdn.net')
  );
}

function isDirectVideo(url) {
  if (!url) return false;
  const path = url.split("?")[0].split("#")[0].toLowerCase();
  return path.endsWith(".mp4") || path.endsWith(".webm") || path.endsWith(".mov");
}

function isCloudinaryVideo(url) {
  return url && /res\.cloudinary\.com\/.+\/(video|raw)\//i.test(url);
}

function getBunnyEmbedUrl(url) {
  if (!url) return null;
  if (url.includes('iframe.mediadelivery.net/embed/')) return url;
  if (url.includes('iframe.mediadelivery.net/play/')) return url.replace('/play/', '/embed/');
  const playerMatch = url.match(/player\.mediadelivery\.net\/play\/(\d+)\/([a-zA-Z0-9-]+)/);
  if (playerMatch) return `https://iframe.mediadelivery.net/embed/${playerMatch[1]}/${playerMatch[2]}?autoplay=false&loop=false&muted=false&preload=true`;
  const bunnyPlay = url.match(/video\.bunnycdn\.com\/play\/(\d+)\/([a-zA-Z0-9-]+)/);
  if (bunnyPlay) return `https://iframe.mediadelivery.net/embed/${bunnyPlay[1]}/${bunnyPlay[2]}?autoplay=false&loop=false&muted=false&preload=true`;
  const guidMatch = url.match(/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);
  const libMatch  = url.match(/\/(\d+)\//);
  if (guidMatch && libMatch) return `https://iframe.mediadelivery.net/embed/${libMatch[1]}/${guidMatch[1]}?autoplay=false&loop=false&muted=false&preload=true`;
  return null;
}

function BunnyPlayer({ url, className = "", autoPlay = false, muted = false, controls = true }) {
  const embedUrl = getBunnyEmbedUrl(url);
  if (embedUrl) {
    const finalUrl = autoPlay ? `${embedUrl.includes('?') ? embedUrl + '&' : embedUrl + '?'}autoplay=true&muted=${muted}` : embedUrl;
    return (
      <div className={`relative w-full aspect-video bg-black ${className}`}>
        <iframe src={finalUrl} className="absolute inset-0 w-full h-full"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
          allowFullScreen title="Bunny Stream Video" loading="lazy" style={{ border: 'none' }} />
      </div>
    );
  }
  return <video src={url} className={`w-full aspect-video bg-black ${className}`} controls={controls} autoPlay={autoPlay} muted={muted} preload="metadata" />;
}

function VideoPlayer({ url, className = "", isReelsStyle = false, autoPlay = false, muted = false, loop = false, controls = true, videoRef = null }) {
  if (!url) return null;
  const ytId = getYouTubeId(url);
  const aspectClass = isReelsStyle ? "h-full w-full" : "aspect-video";
  if (ytId) {
    const ytSrc = `https://www.youtube.com/embed/${ytId}?autoplay=${autoPlay ? 1 : 0}&mute=${muted ? 1 : 0}&loop=${loop ? 1 : 0}&controls=${controls ? 1 : 0}&playsinline=1`;
    return (
      <div className={`relative w-full ${aspectClass} bg-black ${className}`}>
        <iframe src={ytSrc} className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen title="YouTube Video" loading="lazy" style={{ border: 'none' }} />
      </div>
    );
  }
  if (isBunnyUrl(url)) return <BunnyPlayer url={url} className={`${aspectClass} ${className}`} autoPlay={autoPlay} muted={muted} controls={controls} />;
  if (isDirectVideo(url) || isCloudinaryVideo(url)) {
    return (
      <video ref={videoRef} src={url}
        className={`w-full ${aspectClass} bg-black object-cover ${className}`}
        controls={controls} autoPlay={autoPlay} muted={muted} loop={loop} playsInline preload="metadata" />
    );
  }
  return null;
}

// ─────────────────────────────────────────────────────────────────────────────
// TWO-COLUMN "WATERFALL" GRID — shared by Student Testimonials and Video
// Reviews. Always renders exactly 2 columns; each column loops its items in a
// continuous, seamless downward scroll. The viewport is fixed to exactly 2
// item-heights tall, so 4 items (2 columns × 2 rows) are visible at once.
// Both columns are built to the SAME length (cycling through the item list if
// needed) so their loop distance is always identical — with the same duration
// this guarantees the two columns move at exactly the same speed and never
// drift apart, however many items are passed in.
// ─────────────────────────────────────────────────────────────────────────────
function TwoColumnWaterfall({ items, itemHeight = 260, gap = 12, renderItem, baseDuration = 26, isPaused = false }) {
  // NEW: pause the scroll animation whenever this section is scrolled out of
  // the viewport, on top of the existing isPaused (lightbox open) check.
  // Two of these run on the page (Student Testimonials + Video Reviews),
  // each animating two columns — if both keep animating continuously even
  // while off-screen (e.g. while a visitor is up at the hero, or inside the
  // Free Lecture Preview overlay), that's continuous compositor work
  // fighting with everything else on the page for the same frame budget,
  // which is what was showing up as the announcement bar and other
  // sections "hanging"/stuttering. Pausing off-screen sections frees that
  // budget up for whatever's actually visible.
  const containerRef = useRef(null);
  const [inView, setInView] = useState(true);
  useEffect(() => {
    const el = containerRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.05 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const effectivePaused = isPaused || !inView;

  const columns = useMemo(() => {
    if (items.length === 0) return [[], []];
    const colLen = Math.ceil(items.length / 2);
    const colA = [];
    const colB = [];
    for (let i = 0; i < colLen; i++) {
      colA.push({ item: items[i % items.length], originalIndex: i % items.length });
      colB.push({ item: items[(i + colLen) % items.length], originalIndex: (i + colLen) % items.length });
    }
    return [colA, colB];
  }, [items]);

  const viewportHeight = itemHeight * 2 + gap;
  // Height of the progressive blur/fade cap at each edge — content sharpens as
  // it clears this band and blurs+fades as it enters it, disappearing exactly
  // at the boundary.
  const capHeight = Math.round(viewportHeight * 0.24);

  return (
    <div className="relative" ref={containerRef}>
      <style>{`
        @keyframes waterfall-scroll-down {
          0%   { transform: translateY(calc(-1 * var(--scroll-distance, 50%))); }
          100% { transform: translateY(0%); }
        }
      `}</style>
      <div
        className="relative grid grid-cols-2 gap-3 overflow-hidden rounded-2xl"
        style={{
          height: `${viewportHeight}px`,
          // Fades the top/bottom edges of the scrolling grid to fully transparent
          // (so content truly disappears at the boundary, not just blurs) while
          // the middle stays fully opaque/sharp. Combined with the two blur caps
          // below for a soft, gradual transition rather than a harsh cutoff.
          WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)',
          maskImage: 'linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)',
        }}
      >
        {columns.map((colEntries, colIdx) => {
          if (colEntries.length === 0) return null;
          const looped = [...colEntries, ...colEntries];
          // Same duration AND same per-column scroll distance (both columns are
          // built to equal length above) — the two columns move at exactly the
          // same speed, start together, and loop together with no drift. The
          // scroll distance is the exact pixel height of one (un-doubled) copy
          // of the column, so the loop restarts on an exact boundary instead of
          // a flat -50% that can drift by half a gap and cause a visible jump.
          const oneCopyHeight = colEntries.length * itemHeight + Math.max(0, colEntries.length - 1) * gap;
          return (
            <div key={colIdx} className="relative h-full overflow-hidden">
              <div
                className="flex flex-col"
                style={{
                  gap: `${gap}px`,
                  animation: `waterfall-scroll-down ${baseDuration}s linear infinite`,
                  animationPlayState: effectivePaused ? 'paused' : 'running',
                  '--scroll-distance': `${oneCopyHeight}px`,
                  willChange: 'transform',
                }}
              >
                {looped.map((entry, i) => (
                  <div
                    key={i}
                    style={{ height: `${itemHeight}px`, flexShrink: 0 }}
                    aria-hidden={i >= colEntries.length}
                  >
                    {renderItem(entry.item, entry.originalIndex)}
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        {/* EDGE FADE — was a backdrop-blur layer before, but backdrop-filter
            has to be recomputed every single frame while the content behind
            it is actively moving (it can't be cached like a normal blur),
            and with two of these waterfalls plus the marquee bar all
            animating at once, that was the main cause of the whole page
            feeling like it was hanging/stuttering while scrolling — not
            just this section, but the announcement bar too, since it was
            eating the browser's whole rendering budget. A plain gradient
            fade (mask only, no backdrop-blur) looks close enough and costs
            almost nothing to render. */}
        <div
          className="absolute top-0 left-0 right-0 pointer-events-none"
          style={{
            height: `${capHeight}px`,
            background: 'linear-gradient(to bottom, #FDFAF6 0%, transparent 100%)',
          }}
        />
        <div
          className="absolute bottom-0 left-0 right-0 pointer-events-none"
          style={{
            height: `${capHeight}px`,
            background: 'linear-gradient(to top, #FDFAF6 0%, transparent 100%)',
          }}
        />
      </div>
    </div>
  );
}

function VideoReviewsSlider({ videoTestimonials, onCardClick, isPaused }) {
  return (
    <TwoColumnWaterfall
      items={videoTestimonials}
      itemHeight={390}
      gap={12}
      baseDuration={28}
      isPaused={isPaused}
      renderItem={(testimonial, originalIndex) => {
        const ytId = getYouTubeId(testimonial.videoUrl);
        return (
          <div
            role="button"
            tabIndex={0}
            onClick={() => onCardClick(originalIndex)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCardClick(originalIndex); } }}
            className="w-full h-full rounded-xl overflow-hidden relative shadow-lg cursor-pointer group"
          >
            {/* NEW: this tile used to embed a LIVE autoplaying YouTube
                iframe (autoplay=1&loop=1) at all times, even while scrolled
                off-screen — and with the waterfall's loop rendering each
                testimonial twice, that meant several YouTube players
                silently autoplaying simultaneously in the background the
                entire time this page was open. That's exactly the kind of
                thing that starves the main thread/GPU and shows up as
                stutter everywhere else on the page (the announcement bar,
                the scroll animation itself). Now this tile just shows
                YouTube's own static thumbnail with a play button — the
                actual video only ever loads/plays once the visitor taps it
                (via onCardClick, which opens the real player below). */}
            {ytId ? (
              <img
                src={`https://img.youtube.com/vi/${ytId}/hqdefault.jpg`}
                alt="Video testimonial"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            ) : (
              <video
                src={testimonial.videoUrl}
                className="w-full h-full object-cover"
                muted
                playsInline
                preload="metadata"
              />
            )}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-black/50 flex items-center justify-center group-hover:bg-black/70 transition">
                <Play size={22} className="text-white ml-0.5" fill="white" />
              </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-14 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" />
          </div>
        );
      }}
    />
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DEFAULT VIDEO MODAL — the "mobile default" video placement: a plain native
// <video>/embed with the browser's own controls and sound on, the way tapping
// a video normally opens on any website. No custom like/comment/share chrome.
// ─────────────────────────────────────────────────────────────────────────────
function DefaultVideoModal({ isOpen, onClose, videos, startIndex = 0 }) {
  const [currentIndex, setCurrentIndex] = useState(startIndex);

  useEffect(() => { if (isOpen) setCurrentIndex(startIndex); }, [isOpen, startIndex]);
  useEffect(() => {
    if (!isOpen) return undefined;
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [isOpen]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight' && currentIndex < videos.length - 1) setCurrentIndex(i => i + 1);
      if (e.key === 'ArrowLeft' && currentIndex > 0) setCurrentIndex(i => i - 1);
    };
    if (isOpen) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose, currentIndex, videos.length]);

  if (!isOpen) return null;

  const currentVideo = videos[currentIndex];
  const ytId = currentVideo ? getYouTubeId(currentVideo.videoUrl) : null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-xl z-[9999] flex items-center justify-center p-4">
      <button onClick={onClose} aria-label="Close video"
        className="fixed top-4 right-4 z-50 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition border-none cursor-pointer">
        <X size={22} />
      </button>

      {currentIndex > 0 && (
        <button onClick={() => setCurrentIndex(i => i - 1)} aria-label="Previous video"
          className="fixed left-2 md:left-6 top-1/2 -translate-y-1/2 z-50 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition border-none cursor-pointer">
          <ChevronLeft size={24} />
        </button>
      )}
      {currentIndex < videos.length - 1 && (
        <button onClick={() => setCurrentIndex(i => i + 1)} aria-label="Next video"
          className="fixed right-2 md:right-6 top-1/2 -translate-y-1/2 z-50 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition border-none cursor-pointer">
          <ChevronRight size={24} />
        </button>
      )}

      <div className="w-full max-w-3xl">
        {ytId ? (
          <div className="w-full aspect-video bg-black">
            <iframe
              src={`https://www.youtube.com/embed/${ytId}?autoplay=1&mute=0&controls=1&playsinline=1`}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen title="Video" style={{ border: 'none' }} />
          </div>
        ) : (
          <video
            key={currentVideo?.videoUrl}
            src={currentVideo?.videoUrl}
            className="w-full max-h-[85vh] bg-black"
            controls
            autoPlay
            playsInline
          />
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// INSTRUCTOR VIDEO BLOCK — one video link renders as a single clickable card,
// exactly as before. A block with 2+ links (added via "+ Add Another Video"
// on the Instructor Dashboard) renders every video side by side in a small
// grid instead of one-at-a-time — so it's obvious at a glance that there's
// more than one video, with no arrows to click through. Each thumbnail opens
// the full-screen DefaultVideoModal at its own exact position in the
// profile's video list, via clickIndexes[i].
// ─────────────────────────────────────────────────────────────────────────────
function InstructorVideoBlock({ urls, clickIndexes, heading, onOpen }) {
  if (urls.length === 1) {
    const ytId = getYouTubeId(urls[0]);
    return (
      <button
        onClick={() => onOpen(clickIndexes[0])}
        className="relative block w-full aspect-video rounded-xl overflow-hidden border border-[#ece6dd] shadow-sm hover:shadow-md transition cursor-pointer bg-[#2d2416] p-0"
      >
        {ytId && (
          <img src={`https://img.youtube.com/vi/${ytId}/hqdefault.jpg`} alt={heading || 'Video'} className="absolute inset-0 w-full h-full object-cover" />
        )}
        <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
          <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#e8540a] flex items-center justify-center shadow-lg">
            <Play size={16} className="text-white ml-0.5" fill="currentColor" />
          </div>
        </div>
      </button>
    );
  }

  // NEW CHANGE AJ: was a static grid-cols-2 (both videos small, side by side,
  // no motion). Facebook-style slider instead — bigger cards in a horizontally
  // scrollable, snap-to-card row. With exactly 2 videos both are still fully
  // visible (each ~46% of the row width), just larger than before; with 3+
  // videos, both/all are reachable by sliding the row rather than shrinking
  // every card to fit.
  return (
    <div className="relative -mx-1 px-1">
      <div className="fb-video-slider flex gap-3 md:gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-1">
        {urls.map((url, i) => {
          const ytId = getYouTubeId(url);
          return (
            <button
              key={i}
              onClick={() => onOpen(clickIndexes[i])}
              className="relative flex-shrink-0 snap-center block w-[80%] sm:w-[62%] md:w-[49%] h-48 sm:h-56 md:h-64 rounded-xl overflow-hidden border border-[#ece6dd] shadow-sm hover:shadow-md transition cursor-pointer bg-[#2d2416] p-0"
            >
              {ytId && (
                <img src={`https://img.youtube.com/vi/${ytId}/hqdefault.jpg`} alt={heading || 'Video'} className="absolute inset-0 w-full h-full object-cover" />
              )}
              <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#e8540a] flex items-center justify-center shadow-lg">
                  <Play size={20} className="text-white ml-0.5" fill="currentColor" />
                </div>
              </div>
            </button>
          );
        })}
      </div>
      <style>{`
        .fb-video-slider::-webkit-scrollbar { display: none; }
        .fb-video-slider { scrollbar-width: none; -ms-overflow-style: none; }
      `}</style>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// STUDENT TESTIMONIALS — same 2-column waterfall grid, downward-scrolling.
// ─────────────────────────────────────────────────────────────────────────────
function AutoSlideImageTestimonials({ imageTestimonials, onImageClick, isPaused }) {
  return (
    <TwoColumnWaterfall
      items={imageTestimonials}
      itemHeight={390}
      gap={12}
      baseDuration={28}
      isPaused={isPaused}
      renderItem={(testimonial, originalIndex) => (
        <div
          role="button"
          tabIndex={0}
          onClick={() => onImageClick?.(originalIndex)}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onImageClick?.(originalIndex); } }}
          className="w-full h-full rounded-xl overflow-hidden relative shadow-lg cursor-pointer"
        >
          <img
            src={optimizeImage(testimonial.imageUrl, 700)}
            alt={testimonial.author || 'Student testimonial'}
            className="w-full h-full object-cover"
            draggable={false}
            loading="lazy"
            decoding="async"
          />
          <div className="absolute bottom-0 left-0 right-0 h-14 bg-gradient-to-t from-black/70 to-transparent pointer-events-none" />
          {testimonial.author && (
            <p className="absolute bottom-2 left-2 right-2 text-white text-xs sm:text-sm font-semibold drop-shadow line-clamp-1">
              {testimonial.author}
            </p>
          )}
        </div>
      )}
    />
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// IMAGE LIGHTBOX — clicking a Student Testimonial image opens it here at full
// size, mirroring DefaultVideoModal's plain full-screen pattern (close button,
// prev/next arrows, Escape to close, background scroll locked while open).
// ─────────────────────────────────────────────────────────────────────────────
function ImageLightbox({ isOpen, onClose, images, startIndex = 0 }) {
  const [currentIndex, setCurrentIndex] = useState(startIndex);

  useEffect(() => { if (isOpen) setCurrentIndex(startIndex); }, [isOpen, startIndex]);
  useEffect(() => {
    if (!isOpen) return undefined;
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [isOpen]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight' && currentIndex < images.length - 1) setCurrentIndex(i => i + 1);
      if (e.key === 'ArrowLeft' && currentIndex > 0) setCurrentIndex(i => i - 1);
    };
    if (isOpen) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose, currentIndex, images.length]);

  if (!isOpen) return null;

  const current = images[currentIndex];

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-xl z-[9999] flex items-center justify-center p-4">
      <button onClick={onClose} aria-label="Close image"
        className="fixed top-4 right-4 z-50 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition border-none cursor-pointer">
        <X size={22} />
      </button>

      {currentIndex > 0 && (
        <button onClick={() => setCurrentIndex(i => i - 1)} aria-label="Previous image"
          className="fixed left-2 md:left-6 top-1/2 -translate-y-1/2 z-50 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition border-none cursor-pointer">
          <ChevronLeft size={24} />
        </button>
      )}
      {currentIndex < images.length - 1 && (
        <button onClick={() => setCurrentIndex(i => i + 1)} aria-label="Next image"
          className="fixed right-2 md:right-6 top-1/2 -translate-y-1/2 z-50 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition border-none cursor-pointer">
          <ChevronRight size={24} />
        </button>
      )}

      <div className="w-full max-w-3xl flex flex-col items-center">
        <img
          key={current?.imageUrl}
          src={optimizeImage(current?.imageUrl, 1400)}
          alt={current?.author || 'Student testimonial'}
          className="w-full max-h-[80vh] object-contain rounded-lg"
        />
        {current?.author && (
          <p className="text-white/90 text-sm md:text-base font-semibold mt-4">{current.author}</p>
        )}
      </div>
    </div>
  );
}

// ── Course thumbnail with fallback ────────────────────────────────────────
function CourseThumbnail({ course }) {
  const [imgErr, setImgErr] = useState(false);
  const ytId = getYouTubeId(course.previewVideoUrl);
  const thumbnailContent = (
    <div className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-40 transition flex flex-col items-center justify-center gap-3">
      <div className="w-16 h-16 rounded-full bg-[#e8540a] hover:bg-[#c94708] flex items-center justify-center shadow-2xl transition transform group-hover:scale-110">
        <Play size={24} className="text-white ml-1" fill="currentColor" />
      </div>
      <div className="bg-white bg-opacity-90 px-4 py-2 rounded-full inline-block">
        <p className="text-[#1a1208] font-semibold text-base whitespace-nowrap">Free Lectures</p>
      </div>
    </div>
  );
  if (ytId) return (
    <div className="relative w-full h-full bg-[#2d2416] flex items-center justify-center group">
      <img src={`https://img.youtube.com/vi/${ytId}/maxresdefault.jpg`} alt={course.title} className="w-full h-full object-cover" />
      {thumbnailContent}
    </div>
  );
  if (course.thumbnail && !imgErr) return (
    <div className="relative w-full h-full bg-[#2d2416] flex items-center justify-center group">
      <img src={optimizeImage(course.thumbnail, 1280)} alt={course.title} className="w-full h-full object-cover" onError={() => setImgErr(true)} decoding="async" />
      {thumbnailContent}
    </div>
  );
  return (
    <div className="relative w-full h-full bg-[#2d2416] flex items-center justify-center group">
      <span className="text-8xl">{course.emoji || '📚'}</span>
      {thumbnailContent}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// SINGLE REVIEW CARD — fixed height so every visible card lines up. Longer
// reviews never stretch the card: the text is clamped, and "Show more" reveals
// the rest inside an internal scroll area instead of growing the card itself.
// ─────────────────────────────────────────────────────────────────────────────
function ReviewCard({ review, onOpenReviews }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = review.text && review.text.length > 140;

  return (
    <div
      className="flex-shrink-0 w-[280px] sm:w-[320px] h-[300px] bg-white rounded-2xl shadow-sm hover:shadow-md transition border border-[#ece6dd] p-5 flex flex-col cursor-pointer"
      style={{ scrollSnapAlign: 'start' }}
      onClick={onOpenReviews}
      role={onOpenReviews ? 'button' : undefined}
      tabIndex={onOpenReviews ? 0 : undefined}
    >
      <div className="flex items-start gap-3 mb-3 flex-shrink-0">
        <div
          className="w-11 h-11 rounded-full bg-black text-white flex items-center justify-center font-bold text-lg flex-shrink-0 overflow-hidden"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {review.author.charAt(0).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-[#1a1208] text-sm leading-snug break-words">{review.author}</p>
          <div className="flex items-center gap-1.5 mt-1 flex-wrap">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  size={12}
                  className="text-[#f9c97a]"
                  fill={i < Math.round(review.rating) ? 'currentColor' : 'none'}
                />
              ))}
            </div>
            {review.date && <span className="text-xs text-[#9e9789]">{review.date}</span>}
          </div>
        </div>
      </div>

      <div className={`flex-1 min-h-0 ${expanded ? 'overflow-y-auto pr-1' : 'overflow-hidden'}`}>
        {review.text ? (
          <p className={`text-[#3d3020] text-sm leading-relaxed break-words ${expanded ? '' : 'line-clamp-5'}`}>
            {review.text}
          </p>
        ) : (
          <p className="text-[#b0a898] text-sm italic">No written feedback provided.</p>
        )}
      </div>

      {isLong && (
        <button
          onClick={(e) => { e.stopPropagation(); setExpanded((x) => !x); }}
          className="text-[#e8540a] hover:text-[#c94708] font-semibold text-xs mt-2 flex-shrink-0 bg-transparent border-none cursor-pointer p-0 self-start"
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// TEXT REVIEWS SLIDER — horizontal swipe/scroll carousel, no arrow controls.
// Cards are equal height (see ReviewCard). Scrollbar hidden via .reviews-scroll.
// Clicking any card opens the full Ratings & Reviews view inside this page.
// ─────────────────────────────────────────────────────────────────────────────
function TextReviewsList({ reviews, onOpenReviews }) {
  if (!reviews.length) return null;

  return (
    <>
      <style>{`
        .reviews-scroll::-webkit-scrollbar { display: none; }
      `}</style>
      <div
        className="reviews-scroll flex gap-4 overflow-x-auto pb-2"
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          scrollSnapType: 'x proximity',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {reviews.map((review) => (
          <ReviewCard key={review.key} review={review} onOpenReviews={onOpenReviews} />
        ))}
      </div>
    </>
  );
}

// ── Preview player with Meta Pixel free-lecture tracking ─────────────────────
function PreviewVideoWithTracking({ url, course, lecture }) {
  if (!url) return null;

  const ytId     = getYouTubeId(url);
  const isNative = !ytId && !isBunnyUrl(url) && (isDirectVideo(url) || isCloudinaryVideo(url));

  if (!course || !lecture) {
    return <VideoPlayer url={url} className="w-full" />;
  }

  if (isNative) {
    return (
      <FreeLectureVideoTracker
        course={course}
        lecture={lecture}
        src={url}
        className="w-full aspect-video bg-black object-cover"
        controls
      />
    );
  }

  return (
    <FreeLectureIframeTracker course={course} lecture={lecture}>
      <VideoPlayer url={url} className="w-full" />
    </FreeLectureIframeTracker>
  );
}

export default function CourseLandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id }   = useParams();
  const { courses, loading, getCourse, fetchCourseById } = useCourses();
  const { API: api, user } = useAuth();

  const [mobileMenuOpen,        setMobileMenuOpen]        = useState(false);
  // NEW: same expandable "Courses" list as the shared SiteHeader.jsx drawer —
  // this page still has its own separate header/drawer, so the feature has
  // to be added here too rather than being picked up automatically.
  const [coursesExpanded,       setCoursesExpanded]       = useState(false);
  const [expandedSection,       setExpandedSection]       = useState([0, 1, 2]);
  const [showFullDescription,   setShowFullDescription]   = useState(false);
  const [showFullInstructorBio, setShowFullInstructorBio] = useState(false);
  // NEW CHANGE AB: defaults to true now — the Instructor section shows its
  // full description (and any photos/videos in it) as soon as the page
  // loads. Clicking "Show less" collapses it; clicking it again re-expands.
  const [showFullInstructorDescription, setShowFullInstructorDescription] = useState(true);
  const [isPreviewOpen,         setIsPreviewOpen]         = useState(false);
  const [currentVideo,          setCurrentVideo]          = useState('');
  const [activePreviewLecture,  setActivePreviewLecture]  = useState(null);
  // Start from the cached copy when there is one, and only put the page in its
  // "loading" state when there is genuinely nothing to show yet.
  const [fullCourse,            setFullCourse]            = useState(() => readCachedCourse(id));
  const [fullCourseLoading,     setFullCourseLoading]     = useState(() => Boolean(id) && !readCachedCourse(id));
  // NEW: the course exactly as the API returns it. CoursesContext reshapes
  // the course it hands us (it builds instructorId, turns sections' lectures
  // into a count, etc.) and — judging by breadcrumbs / bundles / custom
  // blocks all failing to show up — it only passes through the fields it
  // already knew about, dropping newer ones. Fields added since (custom
  // breadcrumb, bundles, custom blocks, section order) are therefore read
  // straight from this raw copy instead of depending on that reshaping.
  const [rawCourse,             setRawCourse]             = useState(() => readExtrasCache(id));
  const [rawSettled,            setRawSettled]            = useState(() => Boolean(readExtrasCache(id)));
  const navigationType = useNavigationType();
  const [instructorData,        setInstructorData]        = useState(null);
  const [loadingInstructor,     setLoadingInstructor]     = useState(false);
  const [videoReelsOpen,        setVideoReelsOpen]        = useState(false);
  const [videoReelsStartIndex,  setVideoReelsStartIndex]  = useState(0);
  const [imageSliderOpen,       setImageSliderOpen]       = useState(false);
  const [imageSliderStartIndex, setImageSliderStartIndex] = useState(0);

  // NEW: Free Lecture Preview gate — see PreviewLeadGateModal above. Opened
  // the first time (on this device) a visitor clicks any free preview.
  // While previewLocked, the preview section is already open but blurred, its
  // video isn't even loaded, and the form sits on top of it — the video only
  // appears once the form is submitted.
  const [previewGateOpen, setPreviewGateOpen] = useState(false);
  const [previewLocked, setPreviewLocked] = useState(false);

  // The Bundle Offer card carries its own enroll button, so while it's on
  // screen the fixed bottom "Enroll Now" bar (mobile) steps aside — otherwise
  // it sits right under the bundle card as a second, separate offer card.
  const [bundlesEl, setBundlesEl] = useState(null);
  const [bundlesInView, setBundlesInView] = useState(false);
  useEffect(() => {
    if (!bundlesEl || typeof IntersectionObserver === 'undefined') { setBundlesInView(false); return undefined; }
    const observer = new IntersectionObserver(([entry]) => setBundlesInView(entry.isIntersecting), { threshold: 0.05 });
    observer.observe(bundlesEl);
    return () => observer.disconnect();
  }, [bundlesEl]);

  // iPhone "white chalk" at the bottom of the page: rubber-banding past the
  // end of the page shows whatever colour the <html> element has behind the
  // dark footer — plain white here. Android doesn't rubber-band, so it never
  // showed there. The <html> background follows where the visitor is: dark
  // (footer colour) near the bottom, and the top colour near the top, and is
  // put back when leaving this page.
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.style.backgroundColor;
    const update = () => {
      const nearBottom = window.scrollY + window.innerHeight >= root.scrollHeight - 400;
      const topColor = document.querySelector('.announcement-track') ? '#1a1208' : '#ffffff';
      root.style.backgroundColor = nearBottom ? '#1a1208' : topColor;
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      root.style.backgroundColor = previous;
    };
  }, []);

  // Instructor profile media gallery (Photos & Videos, set from the
  // Instructor Dashboard → Profile → Description) — its own lightbox/video
  // modal state, separate from the Student Testimonials / Video Reviews ones
  // above so opening one never affects the other.
  const [instructorImageOpen,      setInstructorImageOpen]      = useState(false);
  const [instructorImageStartIndex, setInstructorImageStartIndex] = useState(0);
  const [instructorVideoOpen,      setInstructorVideoOpen]      = useState(false);
  const [instructorVideoStartIndex, setInstructorVideoStartIndex] = useState(0);

  // ── FOOTER — site logo (Super Admin → Settings), FAQ accordion, newsletter ──
  // NEW: initialize from localStorage (cached from whichever page fetched
  // /settings most recently) so the real logo can show INSTANTLY on this
  // page too, instead of always waiting on a fresh network round-trip. This
  // is what was making the logo feel like it "loads after a delay" every
  // time you moved between pages — each page used to start from blank every
  // time. We still re-fetch in the background below to catch any change.
  const [siteLogoUrl, setSiteLogoUrl] = useState(() => { try { return localStorage.getItem('lerni_header_logo_url') || ''; } catch { return ''; } });
  const [footerLogoUrl, setFooterLogoUrl] = useState(() => { try { return localStorage.getItem('lerni_footer_logo_url') || ''; } catch { return ''; } });
  // logoLoaded starts true if we had a cached value to show immediately;
  // only a first-ever visit (nothing cached yet) shows the blank placeholder
  // while the very first fetch is in flight.
  const [logoLoaded, setLogoLoaded] = useState(() => {
    try { return localStorage.getItem('lerni_header_logo_url') !== null || localStorage.getItem('lerni_footer_logo_url') !== null; } catch { return false; }
  });
  const [openFooterTab, setOpenFooterTab] = useState(null); // 'about' | 'policies' | 'contact' | null
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState('idle'); // idle | sending | sent | error

  // One shared, cached /settings request for the whole app (see
  // utils/siteSettings.js) — it also keeps the logo cache in localStorage up to date.
  useEffect(() => {
    let cancelled = false;
    fetchSiteSettings()
      .then((data) => {
        if (cancelled) return;
        setSiteLogoUrl(data?.logoUrl || '');
        setFooterLogoUrl(data?.footerLogoUrl || '');
      })
      .catch(() => {}) // logo is optional — falls back to the text wordmark
      .finally(() => { if (!cancelled) setLogoLoaded(true); });
    return () => { cancelled = true; };
  }, []);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (!newsletterEmail.trim() || newsletterStatus === 'sending') return;
    setNewsletterStatus('sending');
    api.post('/newsletter', { email: newsletterEmail.trim() })
      .then(() => { setNewsletterStatus('sent'); setNewsletterEmail(''); })
      .catch(() => setNewsletterStatus('error'));
  };

  const [localNewReviews,   setLocalNewReviews]   = useState([]);
  const [fetchedReviews,    setFetchedReviews]    = useState([]);
  const [reviewsOverlayOpen,  setReviewsOverlayOpen]  = useState(false);
  const [reviewsVisibleCount, setReviewsVisibleCount] = useState(10);

  const descriptionRef = useRef(null);
  const instructorSectionRef = useRef(null);
  const viewContentFiredRef = useRef(null);

  // Requirement 3: "Created by <Instructor>" smooth-scrolls to the Instructor
  // section on this same page instead of navigating away.
  const scrollToInstructor = useCallback(() => {
    instructorSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  useEffect(() => {
    if (!id) return;
    const cached = readCachedCourse(id);
    setFullCourse(cached);                 // instantly show the copy we already have (or nothing)
    setFullCourseLoading(!cached);         // …and only block the page with a skeleton when there's nothing to show
    // loadCourseOnce joins a request the home page may already have started
    // (hover/touch on the course card) and saves the result to the cache.
    loadCourseOnce(id, fetchCourseById).then((course) => {
      if (course) setFullCourse(course);
      setFullCourseLoading(false);
    });
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!id) return undefined;
    let cancelled = false;
    const cached = readExtrasCache(id);
    setRawCourse(cached);
    setRawSettled(Boolean(cached));
    api.get(`/courses/${id}`)
      .then((res) => {
        if (cancelled) return;
        const c = res.data || null;
        setRawCourse(c);
        setRawSettled(true);
        if (c) writeExtrasCache(id, c);
      })
      .catch(() => { if (!cancelled) setRawSettled(true); });
    return () => { cancelled = true; };
  }, [id, api]);

  // Fallback: fetch reviews directly when course detail omits reviews_list
  useEffect(() => {
    if (!id) return;
    api.get(`/courses/${id}/reviews`)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setFetchedReviews(list);
      })
      .catch(() => setFetchedReviews([]));
  }, [id, api]);

  const courseData = useMemo(() => {
    // Only trust the full copy if it's actually THIS course — when the route
    // changes to another course the previous one's data is still in state for
    // one render, and it must never flash up under the new URL.
    if (id) return (fullCourse && String(fullCourse._id || fullCourse.id) === String(id)) ? fullCourse : getCourse(id);
    const publishedCourses = courses.filter(c => c.status === 'published');
    return publishedCourses.length > 0 ? publishedCourses[0] : null;
  }, [id, fullCourse, courses, getCourse]);

  // The skeleton below is only shown when there is nothing cached to paint.
  // While it is, the app-wide progress line (see App.jsx / utils/pageProgress.js)
  // runs across the top of the screen.
  const isSkeleton = (loading && !courseData) || fullCourseLoading;
  useEffect(() => {
    if (!isSkeleton) return undefined;
    return beginProgress(); // returns the "done" function, used as the cleanup
  }, [isSkeleton]);

  // ── Keep the scroll position when the visitor comes BACK to this page ─────
  // FIX: after opening a footer link (About, Privacy, Contact…) and pressing
  // Back, the course page came back at the very TOP instead of at the footer
  // the visitor left from. This page re-fetches the course on every visit and
  // shows a short loading skeleton first, so the browser's own scroll
  // restoration has nothing tall enough to restore into and gives up. So the
  // position is remembered here (sessionStorage, per course URL) and put back
  // once the real content is on screen — only when arriving via Back/Forward
  // (POP), never on a fresh visit, which should start at the top.
  const scrollStoreKey = `lerni_course_scroll:${location.pathname}`;
  const scrollPageActiveRef = useRef(true);
  const restoreRef = useRef({ path: null, target: 0, done: false });
  if (restoreRef.current.path !== location.pathname) {
    let saved = 0;
    if (navigationType === 'POP') { try { saved = Number(sessionStorage.getItem(scrollStoreKey)) || 0; } catch { saved = 0; } }
    restoreRef.current = { path: location.pathname, target: saved, done: false };
  }
  useLayoutEffect(() => {
    scrollPageActiveRef.current = true;
    return () => { scrollPageActiveRef.current = false; }; // runs before the DOM is torn down, so a clamped scroll during navigation is never saved
  }, []);
  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        if (!scrollPageActiveRef.current) return;
        if (document.body.dataset.scrollLockY !== undefined) return; // an overlay has the page pinned (scrollY reads 0) — keep the real position
        try { sessionStorage.setItem(scrollStoreKey, String(Math.round(window.scrollY))); } catch { /* ignore */ }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollStoreKey]);
  useLayoutEffect(() => {
    const r = restoreRef.current;
    if (loading || fullCourseLoading || !courseData || r.done || !r.target) return undefined;
    r.done = true;
    let tries = 0;
    let timer = null;
    let cancelled = false;
    const stop = () => { cancelled = true; if (timer) clearTimeout(timer); };
    const attempt = () => {
      if (cancelled) return;
      window.scrollTo({ top: r.target, left: 0, behavior: 'instant' });
      tries += 1;
      // Content below (images, sections) can still be settling — keep nudging
      // for a few seconds until the page is tall enough to land on the spot.
      if (Math.abs(window.scrollY - r.target) > 4 && tries < 25) timer = setTimeout(attempt, 150);
    };
    ['wheel', 'touchstart', 'keydown'].forEach((evt) => window.addEventListener(evt, stop, { once: true, passive: true }));
    attempt();
    return undefined;
  }, [loading, fullCourseLoading, courseData]);

  // ─── FIX 1: Instructor data fetch ───────────────────────────────────────
  useEffect(() => {
    if (!courseData?.instructorId) return;
    setLoadingInstructor(true);
    api.get(`/users/${courseData.instructorId}`)
      .then(res => {
        setInstructorData(res.data);
        setLoadingInstructor(false);
      })
      .catch(err => {
        console.error('Failed to fetch instructor:', err);
        setLoadingInstructor(false);
      });
  }, [courseData?.instructorId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setLocalNewReviews([]);
    setShowFullInstructorBio(false);
    // NEW CHANGE AC: this was resetting the Instructor description back to
    // collapsed (false) every time courseData loaded — which is exactly why
    // "default open" never actually showed up, no matter what the useState
    // default above said. This effect fires right after the course data
    // arrives, so it was winning every time. Reset to true (open) instead,
    // matching the new default.
    setShowFullInstructorDescription(true);
  }, [courseData?._id]);

  const sections = courseData?.sections || [];

  // NEW: no longer falls back to 4 random other published courses when the
  // instructor hasn't picked any — an empty selection now genuinely means
  // "don't show this section" (see the render below, which is already
  // gated on studentsBoughtCourses.length > 0).
  const studentsBoughtCourses = useMemo(() => {
    if (!courseData?._id) return [];
    const picked = courseData.alsoBoughtCourseIds;
    if (!Array.isArray(picked) || picked.length === 0) return [];
    const byId = new Map(courses.map((c) => [String(c._id), c]));
    return picked.map((cid) => byId.get(String(cid))).filter(Boolean)
      .filter((c) => c.status === "published" && String(c._id) !== String(courseData._id));
  }, [courses, courseData?._id, courseData?.alsoBoughtCourseIds]);

  const previewLectures = useMemo(() => {
    const lectures = [];
    sections.forEach((section, sectionIdx) => {
      section.lectures_list?.forEach((lecture, lectureIdx) => {
        if (lecture.preview && lecture.videoUrl) {
          lectures.push({ ...lecture, sectionTitle: section.title, sectionIdx, lectureIdx });
        }
      });
    });
    return lectures;
  }, [sections]);

  const handleNavigate = (path) => {
    setMobileMenuOpen(false);
    try { sessionStorage.setItem(scrollStoreKey, String(Math.round(window.scrollY))); } catch { /* ignore */ }
    navigate(path);
  };

  // Meta Pixel: ViewContent when a specific course landing page loads
  useEffect(() => {
    if (!id || !courseData?._id) return;
    const key = String(courseData._id);
    if (viewContentFiredRef.current === key) return;
    viewContentFiredRef.current = key;
    trackViewContent(courseData);
  }, [id, courseData?._id, courseData?.title]); // eslint-disable-line react-hooks/exhaustive-deps

  // The Bundle Offer's button goes to the SAME enrollment page as every other
  // "Enroll Now" on this page (same route, same tracking) — the bundle id just
  // rides along so that page charges the bundle's price. Because it's the same
  // page, it recognises a returning customer the same way: if they already
  // filled the Course Basic Form, it opens straight on the payment step.
  const handleBundleEnrollClick = (bundle) => {
    if (!courseData?._id) return;
    trackAddToCart(courseData);
    setPendingCourse(courseData);
    const courseId = courseData._id || courseData.id;
    navigate(`/course/${courseId}/enroll${bundle?._id ? `?bundle=${bundle._id}` : ''}`);
    setMobileMenuOpen(false);
  };

  const handleEnrollClick = useCallback(() => {
    if (!courseData?._id) return;
    trackAddToCart(courseData);
    setPendingCourse(courseData);
    const courseId = courseData._id || courseData.id;
    // Goes to the new two-step Enrollment page (name/email/WhatsApp, then
    // payment method) instead of straight to sign-up. That page itself sends
    // guests on to /auth/register once both steps are filled in. If this
    // visitor already passed the free-lecture-preview gate (see
    // getPreviewLead()), EnrolledPage.jsx reads that same stored lead
    // itself and skips straight to Step 2, pre-filled — nothing to pass
    // through the URL for that.
    navigate(`/course/${courseId}/enroll`);
    setMobileMenuOpen(false);
  }, [courseData, navigate]);

  // NEW: opening the Free Lecture Preview modal for the first time pushes an
  // extra history entry on the SAME course page. Previously nothing was
  // pushed here, so pressing the browser Back button while the preview was
  // open just fell through to whatever page came before this course page in
  // history (the Courses page, most of the time) — instead of simply
  // closing the preview and staying on this course. Pushing a marked entry
  // means Back pops that entry first (handled by the effect below, and by
  // handleClosePreview). The `if (!location.state?.coursePreviewOpen)` guard
  // on both handlers below is important: it makes sure switching between
  // lectures while the preview is ALREADY open just swaps the video in
  // place, instead of pushing ANOTHER history entry per lecture — which was
  // the bug where clicking through 3 lectures meant pressing Back 3 times to
  // get back to the course page instead of once.
  //
  // NEW: openPreviewNow()/openLectureNow() are the ACTUAL open logic (what
  // handlePreviewClick/handleLectureClick used to do directly). The two
  // exported handlers now go through the Free Lecture Preview gate first —
  // see PreviewLeadGateModal above — and only call these once a valid lead
  // is already remembered on this device (getPreviewLead()) or was just
  // captured.
  const openPreviewNow = () => {
    setCurrentVideo(courseData?.previewVideoUrl || '');
    setActivePreviewLecture({
      id:    'main-preview',
      _id:   'main-preview',
      title: `${courseData?.title || 'Course'} Preview`,
    });
    setIsPreviewOpen(true);
    if (!location.state?.coursePreviewOpen) {
      navigate(location.pathname + location.search, { state: { ...(location.state || {}), coursePreviewOpen: true } });
    }
  };
  const openLectureNow = (lecture) => {
    setCurrentVideo(lecture.videoUrl);
    setActivePreviewLecture(lecture);
    setIsPreviewOpen(true);
    if (!location.state?.coursePreviewOpen) {
      navigate(location.pathname + location.search, { state: { ...(location.state || {}), coursePreviewOpen: true } });
    }
  };
  // Clicking a free preview opens the Course Preview section straight away;
  // if this visitor hasn't filled the Course Basic Form yet (on this device,
  // within the last 360 days), that section opens BLURRED with the form on top
  // of it and the video held back until the form is submitted.
  const handlePreviewClick = () => {
    openPreviewNow();
    if (!getPreviewLead()) { setPreviewLocked(true); setPreviewGateOpen(true); }
  };
  const handleLectureClick = (lecture) => {
    openLectureNow(lecture);
    if (!getPreviewLead()) { setPreviewLocked(true); setPreviewGateOpen(true); }
  };
  const handlePreviewGateSuccess = () => {
    setPreviewGateOpen(false);
    setPreviewLocked(false);
  };
  const handleClosePreview  = () => {
    setIsPreviewOpen(false);
    setCurrentVideo('');
    setActivePreviewLecture(null);
    setPreviewGateOpen(false);
    setPreviewLocked(false);
    // Pop the ONE history entry we pushed when opening, if we're still on
    // it — keeps Back/Forward in sync with an explicit close (via the X
    // button or Escape), not just a browser Back press.
    if (location.state?.coursePreviewOpen) navigate(-1);
  };

  // Detect a browser Back/Forward press that leaves the "preview open"
  // history entry (rather than an explicit close via the X/Escape above,
  // which already closes the modal itself) and close the modal to match —
  // this is what makes Back land back on this same course page instead of
  // continuing on to wherever the visitor came from.
  //
  // NEW: this is useLayoutEffect rather than useEffect on purpose. Closing
  // via the X button updates state synchronously inside the click handler,
  // so the heavy preview video (a YouTube/Bunny iframe) unmounts in the
  // very same paint. A plain useEffect here would instead run AFTER the
  // browser had already painted one frame with the video still open (React
  // Router updates `location` on the popstate event, that render paints
  // with isPreviewOpen still true, and only the *following* effect closes
  // it) — an extra frame where a heavy video iframe is still actively
  // decoding, right as everything is trying to settle after the
  // navigation. That's what was making the announcement bar visibly
  // stutter specifically after Back, but not after the X button.
  // useLayoutEffect closes it before that first paint instead.
  useLayoutEffect(() => {
    if (isPreviewOpen && !location.state?.coursePreviewOpen) {
      setIsPreviewOpen(false);
      setCurrentVideo('');
      setActivePreviewLecture(null);
      setPreviewGateOpen(false);
      setPreviewLocked(false);
    }
    // Same for the reviews overlay: a browser Back that leaves its history
    // entry closes it and leaves the visitor on this course page.
    if (reviewsOverlayOpen && !location.state?.reviewsOpen) {
      setReviewsOverlayOpen(false);
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // Always call the LATEST close handlers from key listeners — a handler
  // captured when the overlay opened would still see the pre-open history
  // state and leave an extra history entry behind on Escape.
  const closePreviewRef = useRef(null);
  closePreviewRef.current = handleClosePreview;
  const closeReviewsRef = useRef(null);

  useEffect(() => {
    if (!isPreviewOpen) return undefined;
    const handleKeyDown = (e) => { if (e.key === 'Escape') closePreviewRef.current(); };
    window.addEventListener('keydown', handleKeyDown);
    lockBodyScroll();
    return () => { window.removeEventListener('keydown', handleKeyDown); unlockBodyScroll(); };
  }, [isPreviewOpen]);

  const handleToggleDescription = () => {
    if (showFullDescription) {
      const el = descriptionRef.current;
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
      setShowFullDescription(false);
    } else {
      setShowFullDescription(true);
    }
  };

  // Ratings & Reviews open INSIDE this same course page — no route change —
  // the same way the free-lecture preview opens inline. Reachable from the
  // hero rating link, the free-preview rating link, "Show All Reviews", and
  // every individual review card.
  //
  // FIX: opening this overlay never added a browser-history entry, so
  // pressing Back skipped straight past this course to whatever page came
  // before it (another course, in the reported case). It now pushes one
  // history entry when it opens — same technique the free-lecture preview
  // already uses — so Back just closes the overlay and stays on this exact
  // course page. Closing with the arrow / Escape pops that same entry.
  const openReviewsOverlay = useCallback(() => {
    setReviewsVisibleCount(10);
    setReviewsOverlayOpen(true);
    if (!location.state?.reviewsOpen) {
      navigate(location.pathname + location.search, { state: { ...(location.state || {}), reviewsOpen: true } });
    }
  }, [location, navigate]);
  const closeReviewsOverlay = useCallback(() => {
    setReviewsOverlayOpen(false);
    if (location.state?.reviewsOpen) navigate(-1);
  }, [location, navigate]);
  closeReviewsRef.current = closeReviewsOverlay;
  // Tapping the rating line inside the free-lecture preview hops from the
  // preview overlay to the reviews overlay. That must REPLACE the preview's
  // history entry instead of popping it and pushing a new one (the pop is
  // asynchronous and would land on top of the push and close the reviews).
  const switchPreviewToReviews = () => {
    setIsPreviewOpen(false);
    setCurrentVideo('');
    setActivePreviewLecture(null);
    setReviewsVisibleCount(10);
    setReviewsOverlayOpen(true);
    navigate(location.pathname + location.search, { replace: true, state: { ...(location.state || {}), coursePreviewOpen: false, reviewsOpen: true } });
  };

  // While the Ratings & Reviews overlay is open, lock background body scroll
  // (same pattern used for the preview popup / video modal above). Without
  // this, the page behind the fixed overlay could still scroll at the same
  // time as the overlay's own internal scroll area, which is what caused the
  // reviews view to feel like it "hangs" partway through scrolling on mobile.
  useEffect(() => {
    if (!reviewsOverlayOpen) return undefined;
    const handleKeyDown = (e) => { if (e.key === 'Escape') closeReviewsRef.current(); };
    window.addEventListener('keydown', handleKeyDown);
    lockBodyScroll();
    return () => { window.removeEventListener('keydown', handleKeyDown); unlockBodyScroll(); };
  }, [reviewsOverlayOpen]);

  // Loading skeleton — only ever shown when there is NOTHING cached to paint
  // (a first-ever visit to this course). It uses the site's real header (logo
  // straight from the cache) and soft cream blocks, with a progress line
  // across the top. It used to be a plain white bar plus a dark brown band
  // right under it, which read as "a blank white page with a brown stripe".
  // A page that has been opened before never gets here at all (see the cache
  // above), and a cached copy paints while the fresh one loads behind it.
  if (isSkeleton) {
    return (
      <div className="min-h-screen w-full bg-[#FDFAF6]">
        <header className="sticky top-0 z-40 bg-white shadow-sm w-full border-b border-[#ece6dd]">
          <div className="max-w-7xl mx-auto px-4 lg:px-6 py-3 md:py-4 flex items-center justify-between">
            <span className="lg:hidden w-6 h-6 rounded bg-[#f0ebe3] animate-pulse" aria-hidden="true" />
            <div className="absolute left-1/2 transform -translate-x-1/2 lg:relative lg:left-auto lg:transform-none">
              {siteLogoUrl ? (
                <img src={optimizeImage(siteLogoUrl, 400)} alt="Logo" className="h-14 md:h-16 lg:h-20 w-auto object-contain" decoding="async" />
              ) : (
                <span className="inline-block h-14 md:h-16 lg:h-20 w-24" aria-hidden="true" />
              )}
            </div>
            <div className="hidden lg:flex items-center gap-8 flex-1 ml-12" aria-hidden="true">
              {[0, 1, 2, 3, 4].map((i) => <span key={i} className="h-4 w-16 rounded bg-[#f0ebe3] animate-pulse" />)}
            </div>
            <span className="h-9 w-20 md:h-10 md:w-24 rounded-lg bg-[#f0ebe3] animate-pulse" aria-hidden="true" />
          </div>
        </header>
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8 md:py-12">
          <div className="grid lg:grid-cols-3 gap-6 md:gap-8 animate-pulse">
            <div className="lg:col-span-2 space-y-4">
              <div className="h-4 w-48 bg-[#f0ebe3] rounded" />
              <div className="h-9 w-4/5 bg-[#f0ebe3] rounded" />
              <div className="h-9 w-3/5 bg-[#f0ebe3] rounded mb-2" />
              <div className="aspect-video w-full bg-[#f0ebe3] rounded-xl" />
              <div className="h-4 w-full bg-[#f0ebe3] rounded mt-4" />
              <div className="h-4 w-5/6 bg-[#f0ebe3] rounded" />
              <div className="h-4 w-4/6 bg-[#f0ebe3] rounded" />
            </div>
            <div className="hidden lg:block h-80 w-full bg-[#f0ebe3] rounded-2xl" />
          </div>
        </div>
      </div>
    );
  }

  if (!courseData) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FDFAF6] gap-4">
        <p className="text-6xl">😕</p>
        <h2 className="text-2xl font-bold text-[#1a1208]" style={{ fontFamily: "'Playfair Display', serif" }}>Course not found</h2>
        <button onClick={() => navigate('/courses')} className="px-6 py-3 bg-[#e8540a] text-white font-semibold rounded-lg hover:bg-[#c94708] transition border-none cursor-pointer">Browse all courses</button>
      </div>
    );
  }

  // ─── FIX 1: Build instructor object ─────────────────────────────────────
  const instructor = instructorData ? {
    name:        instructorData.name                || courseData.instructor        || 'Instructor',
    title:       instructorData.title               || courseData.instructorTitle   || '',
    location:    instructorData.location            || courseData.instructorLocation|| '',
    website:     instructorData.website             || courseData.instructorWebsite || '',
    twitter:     instructorData.twitter             || courseData.instructorTwitter || '',
    linkedin:    instructorData.linkedin            || courseData.instructorLinkedin|| '',
    rating:      Number(instructorData.totalRatings  ?? courseData.instructorTotalRatings  ?? 0) || 0,
    reviews:     Number(instructorData.totalReviews  ?? courseData.instructorTotalReviews  ?? 0) || 0,
    students:    Number(instructorData.totalStudents ?? courseData.instructorTotalStudents ?? 0) || 0,
    courses:     Number(instructorData.totalCourses  ?? courseData.instructorTotalCourses  ?? 0) || 0,
    bio:         instructorData.bio                 || courseData.instructorBio     || '',
    description: instructorData.instructorDescription || courseData.instructorDescription || '',
    image:       instructorData.avatar              || instructorData.profileImage  || instructorData.instructorImage || courseData.instructorImage || '👩‍💼',
    descriptionBlocks: Array.isArray(instructorData.instructorDescriptionBlocks) && instructorData.instructorDescriptionBlocks.length
      ? instructorData.instructorDescriptionBlocks
      : buildLegacyDescriptionBlocks(
          instructorData.instructorDescription || courseData.instructorDescription || instructorData.bio || courseData.instructorBio || '',
          Array.isArray(instructorData.instructorMedia) ? instructorData.instructorMedia : (Array.isArray(courseData.instructorMedia) ? courseData.instructorMedia : [])
        ),
  } : {
    name:        courseData.instructor        || 'Instructor',
    title:       courseData.instructorTitle   || '',
    location:    courseData.instructorLocation|| '',
    website:     courseData.instructorWebsite || '',
    twitter:     courseData.instructorTwitter || '',
    linkedin:    courseData.instructorLinkedin|| '',
    rating:      Number(courseData.instructorTotalRatings  ?? 0) || 0,
    reviews:     Number(courseData.instructorTotalReviews  ?? 0) || 0,
    students:    Number(courseData.instructorTotalStudents ?? 0) || 0,
    courses:     Number(courseData.instructorTotalCourses  ?? 0) || 0,
    bio:         courseData.instructorBio     || '',
    description: courseData.instructorDescription || '',
    image:       courseData.instructorImage   || '👩‍💼',
    descriptionBlocks: Array.isArray(courseData.instructorDescriptionBlocks) && courseData.instructorDescriptionBlocks.length
      ? courseData.instructorDescriptionBlocks
      : buildLegacyDescriptionBlocks(courseData.instructorDescription || courseData.instructorBio || '', Array.isArray(courseData.instructorMedia) ? courseData.instructorMedia : []),
  };

  // instructor.descriptionBlocks is the ordered paragraph/picture/video list
  // set on the Instructor Dashboard's Profile → Description page. Rendered
  // in exactly that order below (NOT as a separate gallery), and also split
  // out into flat images/videos arrays purely so the lightbox/video modal
  // can page through "all photos" / "all videos" regardless of which one was
  // clicked first.
  const instructorImages = (instructor.descriptionBlocks || [])
    .filter((b) => b.type === 'image' && b.imageUrl)
    .map((b) => ({ imageUrl: b.imageUrl, author: b.heading || '' }));

  // NEW: a video block can now hold several links (added via "+ Add Another
  // Video" on the Instructor Dashboard) instead of just one — getBlockVideoUrls
  // reads either shape: the new `videoUrls` array, or the older single
  // `videoUrl` string, so nothing breaks for a block saved before this change.
  const instructorVideos = (instructor.descriptionBlocks || [])
    .filter((b) => b.type === 'video')
    .flatMap((b) => getBlockVideoUrls(b).map((url) => ({ videoUrl: url, author: b.heading || '' })));

  // The same blocks, in original order, each tagged with what it needs to
  // render: image blocks get a single click-through index into
  // instructorImages; video blocks get an ARRAY of click-through indexes
  // (_clickIndexes), one per video link in that block, into instructorVideos
  // — so InstructorVideoBlock below can render a slider when a block has
  // more than one link and a single card when it has exactly one, while
  // every individual video still opens the full-screen modal at the right
  // spot. Text blocks are left untagged — they render as plain paragraphs.
  let __instrVidIdx = 0, __instrImgIdx = 0;
  const instructorFlowBlocks = (instructor.descriptionBlocks || []).map((b, idx) => {
    if (b.type === 'video') {
      const urls = getBlockVideoUrls(b);
      if (!urls.length) return { ...b, _key: idx, _kind: 'text' };
      const clickIndexes = urls.map(() => __instrVidIdx++);
      return { ...b, _key: idx, _kind: 'video', _urls: urls, _clickIndexes: clickIndexes };
    }
    if (b.type === 'image' && b.imageUrl) return { ...b, _key: idx, _kind: 'image', _clickIndex: __instrImgIdx++ };
    return { ...b, _key: idx, _kind: 'text' };
  });

  const totalLectures = sections.reduce((a, s) => a + (s.lectures || 0), 0);

  // ─── FIX 5 + FIX 6: Build the reviews array ────────────────────────────
  // Merge ALL possible sources (reviews_list, reviews, localNewReviews) then
  // de-dupe by server _id so we never show the same card twice even if both
  // fields are populated. This also fixes "disappears on refresh" — previously
  // safeReviewsArr was skipped whenever reviews_list was non-empty, meaning
  // whichever field the backend uses after a POST was silently ignored.
  const safeReviewsList = Array.isArray(courseData.reviews_list)
    ? courseData.reviews_list.filter(r => r && typeof r === 'object')
    : [];

  const safeReviewsArr = Array.isArray(courseData.reviews)
    ? courseData.reviews.filter(r => r && typeof r === 'object')
    : [];

  // Always merge all sources; de-dupe handles any overlap.
  const rawReviews = [
    ...localNewReviews,
    ...safeReviewsList,
    ...safeReviewsArr,
    ...fetchedReviews,
  ];

  const textReviews = rawReviews
    .map((r, idx) => normalizeReview(r, idx))
    .filter(Boolean)
    // De-dupe by stable key — server _id makes this safe even when both
    // reviews_list and reviews contain the same document.
    .filter((r, idx, arr) => arr.findIndex(x => x.key === r.key) === idx);

  const imageTestimonials = courseData.imageTestimonials || [];
  const videoTestimonials = courseData.videoTestimonials || [];
  const projectGallery    = courseData.projectGallery   || [];

  const discountPct = courseData.originalPrice > courseData.price
    ? Math.round((1 - courseData.price / courseData.originalPrice) * 100)
    : null;
  // NEW CHANGE AI: was multiplying by an approximate USD→PKR rate (×280),
  // which showed a fake, inflated number that didn't match what the
  // instructor actually entered. Course Price / Sale Price are now entered
  // directly in PKR on the Instructor Dashboard, so this just displays the
  // real stored value — discountPct above already compares the real
  // price/originalPrice, so the % off was already correct either way.
  const priceLabel = `PKR ${courseData.price.toLocaleString()}`;

  // NEW: breadcrumb — split on "/" so an instructor can write any custom
  // trail from the Course Editor (e.g. "Marketing / My Custom Title").
  // Falls back to "<category> / <title>" for a course that's never set one.
  // Newer course fields (custom breadcrumb, bundles, custom blocks, section
  // order) come from the raw API copy — see rawCourse above.
  const rawExtras = rawCourse && String(rawCourse._id) === String(courseData._id) ? rawCourse : null;
  const pick = (key) => (rawExtras && rawExtras[key] !== undefined ? rawExtras[key] : courseData[key]);
  const bundles = Array.isArray(pick('bundles')) ? pick('bundles') : [];
  const customBlocks = Array.isArray(pick('customBlocks')) ? pick('customBlocks') : [];
  const editorOrder = Array.isArray(pick('editorSectionOrder')) ? pick('editorSectionOrder') : [];
  const MOVABLE_KEYS = ['imageTestimonials', 'videoTestimonials', 'projectGallery', 'customBlocks', 'bundles'];
  const movableOrder = [...editorOrder.filter((k) => MOVABLE_KEYS.includes(k)), ...MOVABLE_KEYS.filter((k) => !editorOrder.includes(k))];

  // FIX: this always read courseData.breadcrumbText, which never had the
  // instructor's custom text (see rawCourse), so the "<category> / <title>"
  // fallback was all that ever showed.
  const breadcrumbReady = rawSettled || Boolean(rawExtras);
  const breadcrumbSegments = (String(pick('breadcrumbText') || '').trim() || `${courseData.category || 'Courses'} / ${courseData.title}`)
    .split('/').map((s) => s.trim()).filter(Boolean);

  const hasRealReviews = textReviews.length > 0;
  const displayReviews = hasRealReviews ? textReviews : FALLBACK_REVIEWS;
  const displayRating = courseData.rating
    || (hasRealReviews ? (textReviews.reduce((s, r) => s + r.rating, 0) / textReviews.length) : FALLBACK_RATING);

  // Per-course fallback base numbers — reviews land somewhere in 11,800–12,899,
  // enrolled students in 61,001–62,000. Every course gets this base by
  // default; real reviews/enrollments ADD ON TOP of it rather than replacing
  // it, so the number only ever grows from here, never resets to a small
  // real count.
  const courseSeed = courseData._id || courseData.id || courseData.title;
  const fallbackReviewCount  = 11800 + stableCourseOffset(courseSeed, 1100);
  const fallbackStudentCount = 61001 + stableCourseOffset(`${courseSeed}-students`, 999);

  const realReviewCount  = courseData.reviews  || (hasRealReviews ? textReviews.length : 0);
  const realStudentCount = courseData.students || 0;

  const displayRatingCount  = fallbackReviewCount + realReviewCount;
  const displayStudentCount = fallbackStudentCount + realStudentCount;
  const displayRatingDistribution = hasRealReviews ? computeRatingDistribution(textReviews) : FALLBACK_RATING_DISTRIBUTION;

  const movableSections = {
    imageTestimonials: imageTestimonials.length > 0 ? (
      <div className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-2 md:mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Student Testimonials</h2>
        <p className="text-[#9e9789] text-sm md:text-base mb-4 md:mb-6">See what our students have to say</p>
        <AutoSlideImageTestimonials
          imageTestimonials={imageTestimonials}
          onImageClick={(idx) => { setImageSliderStartIndex(idx); setImageSliderOpen(true); }}
          isPaused={imageSliderOpen}
        />
      </div>
    ) : null,

    videoTestimonials: videoTestimonials.length > 0 ? (
      <div className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-2 md:mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Video Reviews</h2>
        <p className="text-[#9e9789] text-sm md:text-base mb-4 md:mb-6">Watch authentic testimonials from our graduates</p>
        <VideoReviewsSlider
          videoTestimonials={videoTestimonials}
          onCardClick={(idx) => { setVideoReelsStartIndex(idx); setVideoReelsOpen(true); }}
          isPaused={videoReelsOpen}
        />
      </div>
    ) : null,

    projectGallery: projectGallery.length > 0 ? (
      <div className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Project gallery</h2>
        <p className="text-sm md:text-base text-[#9e9789] mb-4 md:mb-6">Student work and course outcomes</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {projectGallery.map((item) => (
            <figure key={item.id || item._id || item.imageUrl}
              className="group rounded-2xl overflow-hidden border border-[#ece6dd] bg-white shadow-sm hover:shadow-md transition">
              <div className="aspect-video bg-[#f0ebe3] overflow-hidden">
                <img src={optimizeImage(item.imageUrl, 800)} alt={item.caption || "Project"}
                  className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-300" loading="lazy" decoding="async" />
              </div>
              {item.caption && (
                <figcaption className="px-3 py-2.5 text-sm md:text-base text-[#3d3020] border-t border-[#f0ebe3]">{item.caption}</figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    ) : null,

    // CUSTOM CONTENT BLOCKS — heading, sub heading, a video or image, and an
    // optional FAQ list, exactly as built in the Course Editor. (These were
    // never rendered on this page before.)
    customBlocks: customBlocks.length > 0 ? (
      <div className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full space-y-5 md:space-y-6">
        {customBlocks.map((block, idx) => {
          const faqs = Array.isArray(block.faqs) ? block.faqs.filter((f) => f && String(f.question || '').trim()) : [];
          if (!block.heading && !block.subheading && !block.videoUrl && !block.imageUrl && faqs.length === 0) return null;
          return (
            <div key={block.id || block._id || idx} className="border border-[#ece6dd] rounded-2xl p-5 md:p-7 bg-[#f8f4ed]">
              {block.heading && (
                <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#1a1208] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{block.heading}</h2>
              )}
              {block.subheading && <p className="text-[#6b5e4e] text-sm md:text-base mb-4 leading-relaxed">{block.subheading}</p>}
              {block.videoUrl ? (
                <div className="rounded-xl overflow-hidden mb-4"><VideoPlayer url={block.videoUrl} className="w-full" /></div>
              ) : block.imageUrl ? (
                <img src={optimizeImage(block.imageUrl, 1200)} alt={block.heading || 'Course content'} className="w-full rounded-xl mb-4 object-cover max-h-[28rem]" loading="lazy" decoding="async" />
              ) : null}
              {faqs.length > 0 && (
                <div className="space-y-2">
                  {faqs.map((f, i) => <FaqAccordionItem key={f.id || i} question={f.question} answer={f.answer} />)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    ) : null,

    // BUNDLE OFFER — one card per bundle (see BundleOfferCard). No section
    // heading above it: the card carries its own "Bundle Offer" label.
    bundles: bundles.length > 0 ? (
      <div ref={setBundlesEl} className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full">
        <div className={`grid gap-5 md:gap-6 ${bundles.length > 1 ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1'}`}>
          {bundles.map((bundle, bi) => (
            <BundleOfferCard key={bundle._id || bi} bundle={bundle} footerLogoUrl={footerLogoUrl} onEnroll={() => handleBundleEnrollClick(bundle)} />
          ))}
        </div>
      </div>
    ) : null,
  };

  return (
    <div className="min-h-screen bg-[#FDFAF6] overflow-x-hidden w-full" style={{ fontFamily: "'DM Sans', sans-serif" }}>

      {/* FREE LECTURE PREVIEW GATE — Name/Email/WhatsApp, once per device
          (remembered 360 days). See PreviewLeadGateModal above. */}
      <PreviewLeadGateModal
        isOpen={previewGateOpen}
        onClose={handleClosePreview}
        onSuccess={handlePreviewGateSuccess}
        courseId={courseData._id}
        courseTitle={courseData.title}
        api={api}
        user={user}
      />

      {/* FULL-SCREEN COURSE PREVIEW POPUP */}
      {isPreviewOpen && (
        // FIX: the blur used to be applied to this fixed, full-screen box
        // itself. A CSS blur also blurs the box's own EDGES — they fade to
        // transparent — so a strip all the way around the screen let the page
        // behind show through (the announcement bar at the top, the course
        // page down the right side, a gap at the bottom). Now this outer box
        // stays completely solid and never blurred; only the content inside
        // it is blurred, and it's scaled up slightly so its blurred edges sit
        // outside the screen. The blur therefore covers the whole page and
        // nothing from behind is visible.
        <div className="fixed inset-0 z-[9999] bg-black overflow-hidden">
        <div
          className="absolute inset-0 flex flex-col"
          style={previewLocked
            ? { filter: 'blur(10px)', transform: 'scale(1.08)', pointerEvents: 'none', userSelect: 'none', transition: 'filter .25s ease, transform .25s ease' }
            : { transition: 'filter .25s ease, transform .25s ease' }}
        >
          <div className="absolute top-4 right-4 z-10">
            <button onClick={handleClosePreview}
              className="p-3 bg-white bg-opacity-10 hover:bg-opacity-20 rounded-full transition border-none cursor-pointer backdrop-blur-sm">
              <X size={24} className="text-white" />
            </button>
          </div>
          <div className="w-full bg-gradient-to-r from-[#1a1208] to-[#0f0a05] border-b border-[#3d3020] py-4 md:py-6">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Course Preview</h2>
              <p className="text-base md:text-lg text-[#c8bfaf]">{courseData.title}</p>
            </div>
          </div>
          <div className="w-full bg-black">
            <div className="max-w-7xl mx-auto">
              {previewLocked
                ? <div className="w-full aspect-video bg-black" />
                : <PreviewVideoWithTracking url={currentVideo} course={courseData} lecture={activePreviewLecture} />}
            </div>
          </div>

          {/* Clickable rating link below the free lecture video player — closes this
              preview and opens the Ratings & Reviews view inside the page. */}
          {displayRating > 0 && (
            <div className="w-full bg-black border-b border-[#2d2416]">
              <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
                <div
                  role="button"
                  tabIndex={0}
                  onClick={switchPreviewToReviews}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      switchPreviewToReviews();
                    }
                  }}
                  aria-label="View all course reviews"
                  className="inline-flex items-center gap-1.5 cursor-pointer rounded-md hover:opacity-80 transition focus:outline-none focus:ring-2 focus:ring-[#e8540a] focus:ring-offset-2 focus:ring-offset-black"
                >
                  <Star size={16} className="text-[#f9c97a] md:w-[18px] md:h-[18px]" fill="currentColor" />
                  <span className="text-[#f9c97a] font-bold text-sm md:text-base">{displayRating.toFixed(1)}</span>
                  <span className="text-[#c8bfaf] text-sm md:text-base">·</span>
                  <span className="text-[#c8bfaf] text-sm md:text-base underline decoration-[#c8bfaf]/40">{formatNumber(displayRatingCount)} reviews</span>
                </div>
              </div>
            </div>
          )}

          <div className="flex-1 overflow-y-auto bg-gradient-to-b from-black to-[#1a1208]">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8">
              <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-white mb-4 md:mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>Free Preview Lectures</h3>
              {previewLectures.length === 0 ? (
                <div className="text-center py-12"><p className="text-[#9e8e7a] text-base md:text-lg">No preview lectures available</p></div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                  {previewLectures.map((lecture, idx) => (
                    <div key={`${lecture.sectionIdx}-${lecture.lectureIdx}`}
                      onClick={() => handleLectureClick(lecture)}
                      className="bg-white bg-opacity-5 hover:bg-opacity-10 border border-[#3d3020] rounded-lg p-3 md:p-4 cursor-pointer transition group">
                      <div className="flex items-start gap-3 md:gap-4">
                        <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full bg-[#e8540a] group-hover:bg-[#c94708] flex items-center justify-center transition mt-0.5">
                          <Play size={14} className="text-white ml-0.5" fill="currentColor" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-sm md:text-base text-white group-hover:text-[#f0a070] transition leading-relaxed break-words">{lecture.title}</p>
                          <p className="text-xs md:text-sm text-[#9e8e7a] mt-1">{lecture.sectionTitle}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        </div>
      )}

      {/* RATINGS & REVIEWS — opens inside this same course page (no route change),
          reachable from the hero rating link, the free-preview rating link,
          "Show All Reviews", and any individual review card. */}
      {reviewsOverlayOpen && (
        <div className="fixed inset-0 z-[9999] bg-[#FDFAF6] flex flex-col">
          <div className="sticky top-0 z-10 bg-white border-b border-[#ece6dd] shadow-sm">
            <div className="max-w-4xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center gap-3">
              <button
                onClick={closeReviewsOverlay}
                aria-label="Back to course"
                className="p-2 -ml-2 rounded-full hover:bg-[#f0ebe3] transition border-none bg-transparent cursor-pointer text-[#1a1208]"
              >
                <ArrowLeft size={22} />
              </button>
              {/* Compact dynamic summary, in the exact same typography as the
                  clickable rating line on the main course page (same size,
                  weight, color, tabular-nums number) — not the page-heading
                  serif font used elsewhere. */}
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-3xl md:text-4xl font-bold text-[#1a1208]" style={{ fontVariantNumeric: 'tabular-nums' }}>
                  {displayRating ? displayRating.toFixed(1) : '—'} Reviews
                </span>
                <span className="text-[#9e9789] text-lg md:text-xl">•</span>
                <span className="text-base md:text-lg text-[#9e9789] font-medium">
                  {formatNumber(displayRatingCount)} Reviews
                </span>
              </div>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto">
            <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 md:py-10">
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 md:gap-12 mb-8 md:mb-10 pb-8 md:pb-10 border-b border-[#ece6dd]">
                <div className="flex flex-col items-center flex-shrink-0">
                  <span className="text-5xl md:text-6xl font-bold text-[#1a1208]" style={{ fontVariantNumeric: 'tabular-nums' }}>
                    {displayRating ? displayRating.toFixed(1) : '—'}
                  </span>
                  <div className="flex gap-1 mt-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} size={18} className="text-[#f9c97a]" fill={i < Math.round(displayRating) ? 'currentColor' : 'none'} />
                    ))}
                  </div>
                  <p className="text-base text-[#9e9789] mt-2">{formatNumber(displayRatingCount)} Reviews</p>
                </div>
                <div className="flex-1 w-full">
                  <RatingDistribution distribution={displayRatingDistribution} />
                </div>
              </div>

              <div className="space-y-4 md:space-y-5">
                {displayReviews.slice(0, reviewsVisibleCount).map((review) => (
                  <div key={review.key} className="bg-white border border-[#ece6dd] rounded-2xl p-5 md:p-6">
                    <div className="flex items-start gap-3 mb-3">
                      <div className="w-11 h-11 rounded-full bg-black text-white flex items-center justify-center font-bold text-lg flex-shrink-0 overflow-hidden">
                        {review.author.charAt(0).toUpperCase()}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-bold text-[#1a1208] text-sm md:text-base leading-snug break-words">{review.author}</p>
                        <div className="flex items-center gap-1.5 mt-1 flex-wrap">
                          <div className="flex gap-0.5">
                            {Array.from({ length: 5 }).map((_, i) => (
                              <Star key={i} size={12} className="text-[#f9c97a]" fill={i < Math.round(review.rating) ? 'currentColor' : 'none'} />
                            ))}
                          </div>
                          {review.date && <span className="text-xs text-[#9e9789]">{review.date}</span>}
                        </div>
                      </div>
                    </div>
                    {review.text ? (
                      <p className="text-[#3d3020] text-sm md:text-base leading-relaxed break-words">{review.text}</p>
                    ) : (
                      <p className="text-[#b0a898] text-sm italic">No written feedback provided.</p>
                    )}
                  </div>
                ))}
              </div>

              {reviewsVisibleCount < displayReviews.length && (
                <button
                  onClick={() => setReviewsVisibleCount((c) => c + 10)}
                  className="w-full mt-6 bg-white hover:bg-[#fdf2ea] text-[#e8540a] font-bold py-3 rounded-xl transition text-base border-2 border-[#e8540a] cursor-pointer"
                >
                  Show more reviews
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* DEFAULT VIDEO PLAYER — plain native controls, sound on, opened by tapping
          any tile in the Video Reviews grid. */}
      <DefaultVideoModal
        isOpen={videoReelsOpen}
        onClose={() => setVideoReelsOpen(false)}
        videos={videoTestimonials}
        startIndex={videoReelsStartIndex}
      />

      {/* IMAGE LIGHTBOX — opened by tapping any tile in the Student Testimonials
          grid; the background waterfall keeps auto-scrolling behind it. */}
      <ImageLightbox
        isOpen={imageSliderOpen}
        onClose={() => setImageSliderOpen(false)}
        images={imageTestimonials}
        startIndex={imageSliderStartIndex}
      />

      {/* INSTRUCTOR PHOTOS & VIDEOS — same lightbox/video-modal pattern as the
          testimonial grids above, fed by the instructor's own media gallery. */}
      <DefaultVideoModal
        isOpen={instructorVideoOpen}
        onClose={() => setInstructorVideoOpen(false)}
        videos={instructorVideos}
        startIndex={instructorVideoStartIndex}
      />
      <ImageLightbox
        isOpen={instructorImageOpen}
        onClose={() => setInstructorImageOpen(false)}
        images={instructorImages}
        startIndex={instructorImageStartIndex}
      />

      {/* ANNOUNCEMENT BAR — uses the same real price/originalPrice as the rest
          of the page (was reading the unused `discountPrice` field before,
          so this never actually reflected what the instructor set). */}
      {discountPct > 0 && (
        // NEW: CSS `contain` isolates this bar's rendering from whatever
        // else is happening on the page — a defensive measure so a layout/
        // paint burst elsewhere (like the preview modal tearing down)
        // can't force this bar's own animation to be recomputed in lockstep.
        <div className="bg-[#1a1208] py-2 md:py-3 w-full overflow-hidden" style={{ contain: 'layout style paint' }}>
          <style>{`
            @keyframes announcement-marquee {
              0%   { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .announcement-track {
              display: flex;
              width: max-content;
              animation: announcement-marquee 18s linear infinite;
              will-change: transform;
            }
            .announcement-track:hover {
              animation-play-state: paused;
            }
          `}</style>
          <div className="announcement-track">
            {[0, 1].map((copy) => (
              <span
                key={copy}
                className="text-sm md:text-base font-semibold text-[#f9c97a] whitespace-nowrap px-16"
                aria-hidden={copy === 1}
              >
                Limited Time Offer: Save {discountPct}% — Ends Soon!
                &nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;
                Limited Time Offer: Save {discountPct}% — Ends Soon!
              </span>
            ))}
          </div>
        </div>
      )}

      {/* HEADER */}
      <header className="sticky top-0 z-40 bg-white shadow-sm w-full border-b border-[#ece6dd]">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-3 md:py-4 flex items-center justify-between">
          <button
            className="lg:hidden p-2 -ml-2 bg-transparent border-none cursor-pointer text-[#1a1208]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <div className="absolute left-1/2 transform -translate-x-1/2 lg:relative lg:left-auto lg:transform-none">
            <button onClick={() => handleNavigate('/')}
              className="cursor-pointer hover:opacity-80 transition bg-transparent border-none p-0 flex items-center"
              style={{ fontFamily: "'Playfair Display', serif" }}>
              {!logoLoaded ? (
                <span className="inline-block h-14 md:h-16 lg:h-20 w-24" aria-hidden="true" />
              ) : siteLogoUrl ? (
                <img src={optimizeImage(siteLogoUrl, 400)} alt="Logo" className="h-14 md:h-16 lg:h-20 w-auto object-contain" decoding="async" />
              ) : (
                <span className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-[#1a1208]">
                  Ler<span className="text-[#e8540a]">ni</span>
                </span>
              )}
            </button>
          </div>
          {/* NEW CHANGE N: added Home + Services links alongside the existing ones */}
          <nav className="hidden lg:flex items-center gap-8 flex-1 ml-12">
            <button onClick={() => handleNavigate('/')} className="text-base text-[#3d3020] hover:text-[#e8540a] transition bg-transparent border-none cursor-pointer p-0 font-medium">Home</button>
            <button onClick={() => handleNavigate('/courses')} className="text-base text-[#3d3020] hover:text-[#e8540a] transition bg-transparent border-none cursor-pointer p-0 font-medium">Categories</button>
            <button onClick={() => handleNavigate('/services')} className="text-base text-[#3d3020] hover:text-[#e8540a] transition bg-transparent border-none cursor-pointer p-0 font-medium">Services</button>
            <button onClick={() => handleNavigate('/instructor')} className="text-base text-[#3d3020] hover:text-[#e8540a] transition bg-transparent border-none cursor-pointer p-0 font-medium">Instructor</button>
            <button onClick={() => handleNavigate('/courses')} className="text-base text-[#3d3020] hover:text-[#e8540a] transition bg-transparent border-none cursor-pointer p-0 font-medium">About</button>
          </nav>
          <div className="flex items-center gap-2 md:gap-3">
            <Search className="hidden lg:block text-[#9e9789] cursor-pointer hover:text-[#1a1208] transition" size={22} />
            <button onClick={() => handleNavigate('/auth/login')} className="px-4 md:px-6 py-2 md:py-2.5 bg-[#e8540a] text-white rounded-lg hover:bg-[#c94708] transition font-semibold border-none cursor-pointer text-sm md:text-base shadow-sm">Log In</button>
          </div>
        </div>
        {mobileMenuOpen && (
          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={() => setMobileMenuOpen(false)} />
            <div className="fixed top-0 left-0 h-full w-64 bg-[#1a1208] z-50 lg:hidden shadow-2xl">
              <div className="p-6 space-y-4">
                <div className="flex justify-between items-center mb-6">
                  <span className="text-xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>Menu</span>
                  <button onClick={() => setMobileMenuOpen(false)} className="p-2 hover:bg-white/10 rounded-lg transition bg-transparent border-none cursor-pointer text-white"><X size={24} /></button>
                </div>
                {/* NEW CHANGE N: same Home + Services links added to the mobile drawer */}
                <button onClick={() => handleNavigate('/')} className="block w-full text-left text-white hover:text-[#f0a070] bg-transparent border-none cursor-pointer p-3 rounded-lg hover:bg-white/5 font-medium transition text-base">Home</button>
                {/* NEW: Courses now expands in place to list every course,
                    same as the shared SiteHeader.jsx drawer, instead of
                    navigating straight to the Courses page. */}
                <div>
                  <button
                    onClick={() => setCoursesExpanded(!coursesExpanded)}
                    className="flex w-full items-center justify-between text-left text-white hover:text-[#f0a070] bg-transparent border-none cursor-pointer p-3 rounded-lg hover:bg-white/5 font-medium transition text-base"
                  >
                    Courses
                    <ChevronDown size={16} className={`transition-transform ${coursesExpanded ? 'rotate-180' : ''}`} />
                  </button>
                  {coursesExpanded && (
                    <div className="pl-3 pb-1 space-y-1 max-h-64 overflow-y-auto">
                      {courses && courses.length > 0 ? (
                        courses.map((c) => (
                          <button
                            key={c._id || c.id}
                            onClick={() => handleNavigate(`/course/${c._id || c.id}`)}
                            className="block w-full text-left text-white/80 hover:text-[#f0a070] bg-transparent border-none cursor-pointer px-3 py-2 rounded-lg hover:bg-white/5 text-sm transition truncate"
                          >
                            {c.title}
                          </button>
                        ))
                      ) : (
                        <p className="text-white/50 text-sm px-3 py-2">No courses yet.</p>
                      )}
                    </div>
                  )}
                </div>
                <button onClick={() => handleNavigate('/services')} className="block w-full text-left text-white hover:text-[#f0a070] bg-transparent border-none cursor-pointer p-3 rounded-lg hover:bg-white/5 font-medium transition text-base">Services</button>
                <button onClick={() => handleNavigate('/instructor')} className="block w-full text-left text-white hover:text-[#f0a070] bg-transparent border-none cursor-pointer p-3 rounded-lg hover:bg-white/5 font-medium transition text-base">Instructor</button>
              </div>
            </div>
          </>
        )}
      </header>

      {/* BREADCRUMB — customizable from the Instructor Dashboard's Course
          Editor (courseData.breadcrumbText, split on "/"); falls back to
          "<category> / <title>" when left blank. Plain text (not fixed nav
          links) since the instructor can put anything here now. */}
      <div className="bg-white border-b border-[#ece6dd]">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-2 md:py-3 text-sm md:text-base text-[#9e9789] w-full flex flex-wrap items-center gap-x-2 gap-y-1">
          {/* Until the instructor's own breadcrumb has arrived (or is known to
              be unset), a quiet placeholder holds the space — so the default
              "category / title" trail never shows first and then swaps to the
              custom one a second or two later. Once seen, it's cached, so on
              later visits it's there instantly. */}
          {breadcrumbReady ? breadcrumbSegments.map((seg, i) => (
            <React.Fragment key={i}>
              {i > 0 && <ChevronDown size={16} className="rotate-[-90deg] text-[#ccc5b8] flex-shrink-0" />}
              <span className={i === breadcrumbSegments.length - 1 ? "text-[#1a1208] font-semibold break-words" : "text-[#9e9789]"}>{seg}</span>
            </React.Fragment>
          )) : (
            <span className="inline-block h-5 w-56 max-w-full rounded bg-[#f0ebe3] animate-pulse" aria-hidden="true" />
          )}
        </div>
      </div>

      {/* COURSE HERO SECTION */}
      <section className="w-full bg-[#1a1208] text-white py-6 md:py-8 lg:py-12 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="grid lg:grid-cols-3 gap-6 md:gap-8">
            <div className="lg:col-span-2">
              <div className="mb-3 md:mb-4 flex items-center gap-2 flex-wrap">
                {courseData.bestseller && (
                  <span className="inline-flex items-center gap-1 bg-[#f9c97a] text-[#7a4a00] font-bold px-3 md:px-4 py-1.5 md:py-2 rounded text-sm">
                    <Award size={14} /> Bestseller
                  </span>
                )}
                {courseData.level && (
                  <span className="inline-block bg-[#e8540a] text-white font-semibold px-3 md:px-4 py-1.5 md:py-2 rounded text-sm">Beginner to Advanced</span>
                )}
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-3 md:mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>{courseData.title}</h1>
              <p className="text-lg md:text-xl lg:text-2xl text-[#c8bfaf] mb-4 md:mb-6 leading-relaxed">{courseData.subtitle}</p>
              <div className="-mx-4 lg:-mx-6 mb-4 md:mb-6">
                <div className="relative w-full bg-black aspect-video cursor-pointer select-none" style={{ WebkitTapHighlightColor: 'transparent' }} onClick={handlePreviewClick}>
                  <CourseThumbnail course={courseData} />
                </div>
              </div>
              {/* Rating link below the free lecture video player — the entire area is
                  clickable and opens the Ratings & Reviews view inside this page. */}
              <div className="flex flex-wrap items-center gap-3 md:gap-4 mb-4 md:mb-6">
                {displayRating > 0 && (
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={openReviewsOverlay}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        openReviewsOverlay();
                      }
                    }}
                    aria-label="View all course reviews"
                    className="flex items-center gap-1.5 cursor-pointer rounded-md hover:opacity-80 transition focus:outline-none focus:ring-2 focus:ring-[#e8540a] focus:ring-offset-2 focus:ring-offset-[#1a1208]"
                  >
                    <Star size={16} className="text-[#f9c97a] md:w-[18px] md:h-[18px]" fill="currentColor" />
                    <span className="text-[#f9c97a] font-bold text-sm md:text-base">{displayRating.toFixed(1)}</span>
                    <span className="text-[#c8bfaf] text-sm md:text-base">·</span>
                    <span className="text-[#c8bfaf] text-sm md:text-base underline decoration-[#c8bfaf]/40">{formatNumber(displayRatingCount)} reviews</span>
                  </div>
                )}
                <div className="flex items-center gap-1.5 text-[#c8bfaf] text-sm md:text-base">
                  <Users size={16} /><span>{displayStudentCount.toLocaleString()} students</span>
                </div>
              </div>
              <div className="mb-4 md:mb-6">
                <p className="text-[#9e8e7a] text-sm md:text-base">
                  Created by{' '}
                  <button onClick={scrollToInstructor}
                    className="text-[#e87040] hover:text-[#f0a070] font-semibold bg-transparent border-none cursor-pointer p-0 underline">
                    {instructor.name}
                  </button>
                  {instructor.title && (
                    <span className="text-[#c8bfaf]"> · {instructor.title}</span>
                  )}
                </p>
              </div>
              <div className="flex flex-wrap gap-3 md:gap-4 text-[#7a6e62] text-sm md:text-base">
                <div className="flex items-center gap-1.5"><Clock size={16} /><span>Last updated {courseData.lastUpdated || 'Recently'}</span></div>
                <div className="flex items-center gap-1.5"><Globe size={16} /><span>Urdu</span></div>
              </div>
            </div>

            {/* Desktop sidebar card */}
            <div className="hidden lg:block">
              <div className="sticky top-24">
                <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-[#ece6dd]">
                  <div className="relative aspect-video cursor-pointer group select-none" style={{ WebkitTapHighlightColor: 'transparent' }} onClick={handlePreviewClick}>
                    <CourseThumbnail course={courseData} />
                  </div>
                  <div className="p-6">
                    <div className="flex items-baseline gap-3 mb-4">
                      <span className="text-3xl font-bold text-[#1a1208]" style={{ fontFamily: "'Playfair Display', serif" }}>
                        {priceLabel}
                      </span>
                      {discountPct && <span className="text-base font-semibold text-[#e8540a]">{discountPct}% off</span>}
                    </div>
                    <button onClick={handleEnrollClick}
                      className="w-full bg-[#e8540a] hover:bg-[#c94708] text-white font-bold py-3 rounded-xl transition text-lg border-none cursor-pointer shadow-lg mb-3">
                      {discountPct ? (
                        <span>Enroll Now • {priceLabel} • <span className="text-[#fde8d8]">{discountPct}% OFF</span></span>
                      ) : `Enroll Now in ${priceLabel}`}
                    </button>
                    <button onClick={handleEnrollClick}
                      className="w-full bg-white hover:bg-[#f8f4ed] text-[#1a1208] font-semibold py-3 rounded-xl transition text-lg border-2 border-[#ece6dd] cursor-pointer">
                      Buy now
                    </button>
                    <p className="text-center text-sm text-[#9e9789] mt-4 flex items-center justify-center gap-1.5">
                      <Shield size={14} className="text-[#3d7a4e]" />30-Day Money-Back Guarantee
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="w-full bg-white py-8 md:py-12 lg:py-16 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="grid lg:grid-cols-3 gap-6 md:gap-8">
            <div className="lg:col-span-2 w-full min-w-0">

              {/* WHAT YOU'LL LEARN */}
              {courseData.whatYouLearn?.length > 0 && (
                <div className="mb-8 md:mb-12 w-full">
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-4 md:mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>What you'll learn</h2>
                  <div className="border border-[#ece6dd] rounded-2xl p-4 md:p-6 lg:p-8 bg-[#f8f4ed] w-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                      {courseData.whatYouLearn.map((outcome, idx) => (
                        <div key={idx} className="flex gap-2 md:gap-3 items-start">
                          <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#e8540a] flex items-center justify-center flex-shrink-0 mt-0.5">
                            <Check size={12} className="text-white" strokeWidth={3} />
                          </div>
                          <p className="text-[#3d3020] text-sm md:text-base leading-relaxed">{outcome}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* COURSE CONTENT — titles wrap naturally, no ellipsis/truncation */}
              {sections.length > 0 && (
                <>
                  <div className="mb-4 md:mb-6">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Course Content</h2>
                    <div className="flex flex-wrap gap-2 text-[#9e9789] text-sm md:text-base">
                      <span className="font-semibold text-[#1a1208]">{sections.length} sections</span>
                      <span>•</span>
                      <span className="font-semibold text-[#1a1208]">{totalLectures} lectures</span>
                      {courseData.duration && <><span>•</span><span>{courseData.duration} total length</span></>}
                    </div>
                  </div>
                  <div className="space-y-2 mb-8 md:mb-12 w-full">
                    {sections.map((section, idx) => {
                      const isExpanded = expandedSection.includes(idx);
                      return (
                        <div key={idx} className="border border-[#ece6dd] rounded-xl overflow-hidden hover:border-[#ddd5c4] transition w-full">
                          <button
                            onClick={() => setExpandedSection(isExpanded ? expandedSection.filter(i => i !== idx) : [...expandedSection, idx])}
                            className="w-full px-4 md:px-5 py-3 md:py-4 flex items-start justify-between bg-[#f8f4ed] hover:bg-[#f0ebe3] transition border-none cursor-pointer text-left">
                            <div className="flex items-start gap-2 md:gap-3 flex-1 text-left min-w-0">
                              <ChevronDown size={18} className={`text-[#9e9789] transition-transform flex-shrink-0 mt-0.5 ${isExpanded ? 'rotate-180' : ''}`} />
                              <div className="flex-1 min-w-0">
                                <h3 className="font-bold text-[#1a1208] text-base md:text-lg leading-snug break-words">{section.title}</h3>
                                <p className="text-sm text-[#9e9789] mt-1">{section.lectures || 0} lectures{section.duration ? ` • ${section.duration}` : ''}</p>
                              </div>
                            </div>
                          </button>
                          {isExpanded && section.lectures_list?.length > 0 && (
                            <div className="border-t border-[#ece6dd] bg-white">
                              {section.lectures_list.map((lecture, lectureIdx) => {
                                const isClickable = Boolean(lecture.preview && lecture.videoUrl);
                                return (
                                  <div
                                    key={lectureIdx}
                                    onClick={isClickable ? () => handleLectureClick(lecture) : undefined}
                                    onKeyDown={isClickable ? (e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        handleLectureClick(lecture);
                                      }
                                    } : undefined}
                                    role={isClickable ? 'button' : undefined}
                                    tabIndex={isClickable ? 0 : undefined}
                                    aria-label={isClickable ? `Play free lecture: ${lecture.title}` : undefined}
                                    style={{ WebkitTapHighlightColor: 'transparent' }}
                                    className={`px-4 md:px-6 py-3 md:py-3.5 border-b border-[#f0ebe3] last:border-b-0 flex items-start justify-between gap-3 transition ${isClickable ? 'cursor-pointer hover:bg-[#fbf8f3] focus:outline-none focus:bg-[#fbf8f3]' : ''}`}
                                  >
                                    <div className="flex items-start gap-2 md:gap-3 flex-1 min-w-0">
                                      <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#f0ebe3] flex items-center justify-center flex-shrink-0 mt-0.5">
                                        {lecture.type === 'video'
                                          ? <Play size={12} className="text-[#6b5e4e] ml-0.5" />
                                          : <BookOpen size={12} className="text-[#6b5e4e]" />}
                                      </div>
                                      <p className="text-[#1a1208] text-sm md:text-base font-medium leading-relaxed break-words">{lecture.title}</p>
                                    </div>
                                    <div className="flex items-center gap-2 md:gap-3 flex-shrink-0 mt-0.5">
                                      {lecture.duration && <span className="text-sm text-[#9e9789] whitespace-nowrap">{lecture.duration}</span>}
                                      {isClickable && (
                                        <span className="flex items-center bg-[#e8540a] text-white font-semibold text-xs md:text-sm whitespace-nowrap px-2.5 py-1.5 rounded-full">
                                          Free Lecture
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              {/* REQUIREMENTS */}
              {courseData.requirements?.length > 0 && (
                <div className="mb-8 md:mb-12 w-full">
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-4 md:mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>Requirements</h2>
                  <div className="border border-[#ece6dd] rounded-2xl p-4 md:p-6 lg:p-8 bg-[#f8f4ed] w-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                      {courseData.requirements.map((req, idx) => (
                        <div key={idx} className="flex gap-2 md:gap-3 items-start">
                          <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#e8540a] flex items-center justify-center flex-shrink-0 mt-0.5">
                            <Check size={12} className="text-white" strokeWidth={3} />
                          </div>
                          <p className="text-[#3d3020] text-sm md:text-base leading-relaxed">{req}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* DESCRIPTION */}
              {courseData.description && (
                <div className="mb-8 md:mb-12 w-full" ref={descriptionRef}>
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Description</h2>
                  <div className="relative">
                    <div
                      className={`text-[#3d3020] leading-relaxed text-sm md:text-base lerni-prose max-w-none ${!showFullDescription ? 'max-h-48 overflow-hidden' : ''}`}
                      style={{ wordBreak: 'break-word' }}
                      dangerouslySetInnerHTML={{ __html: richTextToHtml(courseData.description) }}
                    />
                    {!showFullDescription && (
                      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white via-white/90 to-transparent pointer-events-none" />
                    )}
                  </div>
                  <button onClick={handleToggleDescription}
                    className="text-[#e8540a] hover:text-[#c94708] mt-3 text-sm md:text-base font-bold transition flex items-center gap-1 bg-transparent border-none cursor-pointer p-0 mx-auto sm:mx-0">
                    <span>{showFullDescription ? 'Show less' : 'Show more'}</span>
                    <ChevronDown size={16} className={`transition-transform ${showFullDescription ? 'rotate-180' : ''}`} />
                  </button>
                </div>
              )}

              {/* INSTRUCTOR — circular photo + stat grid beside it (desktop), stacked (mobile) */}
              <div className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full" ref={instructorSectionRef} id="instructor-section">
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-6 md:mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>Instructor</h2>
                {loadingInstructor ? (
                  <p className="text-[#9e9789] text-base md:text-lg">Loading instructor...</p>
                ) : (
                  <div className="border border-[#ece6dd] rounded-2xl p-5 md:p-8 bg-[#f8f4ed] w-full">
                    {/* PROFILE ROW — two columns side by side at ALL breakpoints (never stacks
                        the photo above the stats, even on mobile):
                          LEFT column  = circular photo, with Name + Title directly beneath it
                          RIGHT column = Total Rating / Reviews / Students / Courses, icons
                                         aligned in a straight sequence with each other */}
                    <div className="flex flex-row items-start gap-8 sm:gap-12 md:gap-16">
                      {/* LEFT: photo + name + title, stacked as one column.
                          Column is a touch wider than the photo itself (photo size is
                          unchanged) so a typical two-word instructor name has room to sit
                          on a single line instead of wrapping. */}
                      <div className="flex flex-col items-center flex-shrink-0 w-32 sm:w-40 md:w-48">
                        <div className="w-28 h-28 sm:w-36 sm:h-36 md:w-44 md:h-44 rounded-full overflow-hidden bg-[#f0ebe3] border-4 border-white shadow-md flex-shrink-0" style={{ aspectRatio: '1 / 1' }}>
                          {instructor.image && instructor.image.startsWith('http') ? (
                            <img src={optimizeImage(instructor.image, 400)} alt={instructor.name} className="w-full h-full object-cover" decoding="async" />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center bg-[#e8540a]">
                              <span className="text-white font-bold text-3xl sm:text-4xl md:text-5xl">{instructor.name?.charAt(0) || 'I'}</span>
                            </div>
                          )}
                        </div>
                        <p className="mt-3 font-bold text-[#1a1208] text-sm sm:text-lg md:text-xl leading-tight text-center whitespace-nowrap" style={{ fontFamily: "'Playfair Display', serif" }}>
                          {instructor.name}
                        </p>
                        {instructor.title && (
                          <p className="mt-1 text-sm sm:text-base md:text-lg text-[#9e9789] font-medium text-center break-words">{instructor.title}</p>
                        )}
                      </div>

                      {/* RIGHT: stat cards — 2x2 grid, Udemy-style.
                          NEW CHANGE AD: on Android the icon+gap were eating so much of each
                          card's already-narrow width that even single words like "Total" or
                          "Rating" didn't fit — and break-words was then splitting mid-word
                          ("TO"/"TAL", "RA"/"TING") to force them in, since overflow-wrap:
                          break-word breaks inside a word once it has no other choice. iPhone
                          happened to render the same layout just wide enough to never hit that
                          case, which is why it looked fine there. Real fix: (1) never let text
                          fracture mid-word — swap break-words for plain wrapping, which only
                          breaks at the space in "Total Rating" and otherwise lets a card clip
                          via its own overflow-hidden instead of shredding letters; (2) stack the
                          icon above the value/label at the smallest size instead of beside it,
                          so the label gets the card's full width to wrap into on narrow phones,
                          then return to the icon-beside-text row from sm: up. */}
                      <div className="grid grid-cols-2 gap-2 sm:gap-3.5 flex-1 min-w-0 pt-1 sm:pt-4 md:pt-6">
                        {[
                          { label: 'Total Rating', value: instructor.rating > 0 ? instructor.rating.toFixed(1) : '0', Icon: Star },
                          { label: 'Reviews', value: formatNumber(instructor.reviews), Icon: MessageCircle },
                          { label: 'Students', value: formatNumber(instructor.students), Icon: Users },
                          { label: 'Courses', value: formatNumber(instructor.courses), Icon: BookOpen },
                        ].map((stat) => {
                          const StatIcon = stat.Icon;
                          return (
                            <div key={stat.label} className="flex flex-col sm:flex-row items-center sm:items-center gap-1 sm:gap-3 bg-white rounded-xl border border-[#ece6dd] px-1.5 sm:px-4 py-2 sm:py-3 overflow-hidden text-center sm:text-left">
                              <div className="w-6 h-6 sm:w-9 sm:h-9 rounded-full bg-[#fdf0e4] flex items-center justify-center flex-shrink-0">
                                <StatIcon size={12} className="text-[#e8540a] sm:hidden" fill={StatIcon === Star ? 'currentColor' : 'none'} />
                                <StatIcon size={14} className="text-[#e8540a] hidden sm:block" fill={StatIcon === Star ? 'currentColor' : 'none'} />
                              </div>
                              <div className="min-w-0 flex-1 w-full">
                                <p className="text-sm sm:text-base md:text-lg font-bold text-[#1a1208] leading-tight">{stat.value}</p>
                                <p className="text-[10px] sm:text-xs text-[#9e9789] leading-tight whitespace-normal break-normal">{stat.label}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* INSTRUCTOR DESCRIPTION — one flowing mix of paragraphs, photos
                        and videos, in exactly the order set on the Instructor
                        Dashboard's Profile → Description page (not a separate
                        gallery below the text — a photo or video can sit right
                        after any paragraph). Open by default; "Show less"
                        collapses it, and clicking again re-expands. */}
                    <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-[#ece6dd] text-center sm:text-left">
                      {instructorFlowBlocks.length > 0 && (
                        <div className="mt-4">
                          {/* The fade overlay is scoped to ONLY this inner wrapper (not the
                              button below), and only shows up while collapsed. */}
                          <div className="relative">
                            <div className={`text-left space-y-4 ${!showFullInstructorDescription ? 'max-h-64 overflow-hidden' : ''}`}>
                              {instructorFlowBlocks.map((block) => {
                                if (block._kind === 'text') {
                                  if (!block.text) return null;
                                  return (
                                    <div
                                      key={block._key}
                                      className="text-[#3d3020] text-sm md:text-base leading-relaxed break-words lerni-prose max-w-none"
                                      dangerouslySetInnerHTML={{ __html: richTextToHtml(block.text) }}
                                    />
                                  );
                                }

                                const isVideo = block._kind === 'video';
                                const onImageClick = () => { setInstructorImageStartIndex(block._clickIndex); setInstructorImageOpen(true); };

                                return (
                                  <div key={block._key}>
                                    {block.heading && <p className={`${blockTextClass(block, 'heading')} text-[#1a1208] mb-2`}>{block.heading}</p>}
                                    {isVideo ? (
                                      <InstructorVideoBlock
                                        urls={block._urls}
                                        clickIndexes={block._clickIndexes}
                                        heading={block.heading}
                                        onOpen={(clickIndex) => { setInstructorVideoStartIndex(clickIndex); setInstructorVideoOpen(true); }}
                                      />
                                    ) : (
                                      <button
                                        onClick={onImageClick}
                                        className="block w-full rounded-xl overflow-hidden border border-[#ece6dd] shadow-sm hover:shadow-md transition cursor-pointer bg-white p-0"
                                      >
                                        <img src={optimizeImage(block.imageUrl, 1000)} alt={block.heading || 'Photo'} className="w-full max-h-80 object-cover" loading="lazy" decoding="async" />
                                      </button>
                                    )}
                                    {block.description && <p className={`${blockTextClass(block, 'description')} text-[#9e9789] mt-2`}>{block.description}</p>}
                                  </div>
                                );
                              })}
                            </div>
                            {!showFullInstructorDescription && (
                              <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-[#f8f4ed] via-[#f8f4ed]/90 to-transparent pointer-events-none" />
                            )}
                          </div>
                          <button
                            onClick={() => setShowFullInstructorDescription((v) => !v)}
                            className="text-[#e8540a] hover:text-[#c94708] mt-3 text-sm md:text-base font-bold transition flex items-center gap-1 bg-transparent border-none cursor-pointer p-0 mx-auto sm:mx-0"
                          >
                            <span>{showFullInstructorDescription ? 'Show less' : 'Show more'}</span>
                            <ChevronDown size={16} className={`transition-transform ${showFullInstructorDescription ? 'rotate-180' : ''}`} />
                          </button>
                        </div>
                      )}

                      {(instructor.website || instructor.twitter || instructor.linkedin) && (
                        <div className="flex flex-wrap justify-center sm:justify-start gap-3 text-sm text-[#9e9789] mt-4">
                          {instructor.website && (
                            <a href={instructor.website.startsWith('http') ? instructor.website : `https://${instructor.website}`}
                              target="_blank" rel="noopener noreferrer"
                              className="text-[#e8540a] hover:underline">Website</a>
                          )}
                          {instructor.twitter && <span>Twitter: {instructor.twitter}</span>}
                          {instructor.linkedin && (
                            <a href={instructor.linkedin.startsWith('http') ? instructor.linkedin : `https://${instructor.linkedin}`}
                              target="_blank" rel="noopener noreferrer"
                              className="text-[#e8540a] hover:underline">LinkedIn</a>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* ─────────────────────────────────────────────────────────────
                  TEXT REVIEWS — equal-height horizontal slider (no arrows).
                  Header reads "★ rating • X ratings". Every review card is the
                  same size; long reviews scroll internally via "Show more"
                  instead of stretching the card.
              ───────────────────────────────────────────────────────────── */}
              <div className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full">
                <div
                  className="mb-6 md:mb-8 flex items-center gap-2 cursor-pointer w-fit"
                  role="button"
                  tabIndex={0}
                  onClick={openReviewsOverlay}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openReviewsOverlay(); } }}
                  aria-label="View all course reviews"
                >
                  <Star size={28} className="text-[#f9c97a] flex-shrink-0" fill="currentColor" />
                  <span className="text-3xl md:text-4xl font-bold text-[#1a1208]" style={{ fontVariantNumeric: 'tabular-nums' }}>
                    {displayRating ? displayRating.toFixed(1) : '—'}
                  </span>
                  {displayRatingCount > 0 && (
                    <>
                      <span className="text-[#9e9789] text-lg md:text-xl">•</span>
                      <span className="text-base md:text-lg text-[#9e9789] font-medium underline decoration-[#9e9789]/40">
                        {formatNumber(displayRatingCount)} Reviews
                      </span>
                    </>
                  )}
                </div>

                {displayReviews.length === 0 ? (
                  <div className="border border-dashed border-[#ddd5c4] rounded-2xl p-8 text-center bg-[#fbf8f3]">
                    <p className="text-[#9e9789] text-sm md:text-base">Be the first to leave a review for this course.</p>
                  </div>
                ) : (
                  <TextReviewsList reviews={displayReviews} onOpenReviews={openReviewsOverlay} />
                )}
              </div>

              {/* SHOW ALL REVIEWS — opens the Ratings & Reviews view inside this page */}
              <div className="mb-8 md:mb-12 pt-6 md:pt-8 border-t border-[#ece6dd] w-full">
                <button
                  onClick={openReviewsOverlay}
                  className="w-full bg-white hover:bg-[#fdf2ea] text-[#e8540a] font-bold py-3 md:py-3.5 rounded-xl transition text-base md:text-lg border-2 border-[#e8540a] cursor-pointer">
                  Show All Reviews
                </button>
              </div>

              {/* Everything from here down follows the order the instructor set in
                  the Course Editor (drag ☰ / ▲▼): student testimonials, video
                  reviews, project gallery, custom blocks, bundles. */}
              {movableOrder.map((key) => (
                <React.Fragment key={key}>{movableSections[key]}</React.Fragment>
              ))}
            </div>

            {/* Sidebar (Desktop) */}
            <div className="hidden lg:block lg:col-span-1">
              <div className="sticky top-24">
                <div className="bg-white border border-[#ece6dd] rounded-2xl p-6 mb-6 shadow-sm">
                  <h3 className="text-xl font-bold text-[#1a1208] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>This course includes:</h3>
                  <div className="space-y-3">
                    {[
                      { icon: Film, text: courseData.duration ? `${courseData.duration} on-demand video` : 'On-demand video' },
                      { icon: Download, text: 'Downloadable resources' },
                      { icon: Smartphone, text: 'Access on mobile and TV' },
                      { icon: Shield, text: 'Full lifetime access' },
                      { icon: Award, text: 'Certificate of completion' },
                    ].map((item, idx) => {
                      const Icon = item.icon;
                      return (
                        <div key={idx} className="flex items-center gap-3 pb-3 border-b border-[#f0ebe3] last:border-b-0 last:pb-0">
                          <Icon size={20} className="text-[#e8540a]" />
                          <p className="text-base text-[#3d3020]">{item.text}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* STUDENTS ALSO BOUGHT */}
          {studentsBoughtCourses.length > 0 && (
            <div className="mt-12 md:mt-16 pt-8 md:pt-12 border-t border-[#ece6dd]">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1a1208] mb-6 md:mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>Students also bought</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                {studentsBoughtCourses.map(course => (
                  <div key={course._id} onClick={() => navigate(`/course/${course._id}`)}
                    className="bg-white border border-[#ece6dd] rounded-2xl overflow-hidden hover:shadow-lg transition cursor-pointer group">
                    <div className="h-36 md:h-44 bg-[#f0ebe3] flex items-center justify-center relative overflow-hidden">
                      {course.thumbnail
                        ? <img src={optimizeImage(course.thumbnail, 500)} alt={course.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" decoding="async" />
                        : <span className="text-5xl md:text-6xl">{course.emoji || '📚'}</span>}
                    </div>
                    <div className="p-3 md:p-4">
                      <h3 className="font-bold text-[#1a1208] text-sm md:text-base mb-2 line-clamp-2 group-hover:text-[#e8540a] transition">{course.title}</h3>
                      <p className="text-xs md:text-sm text-[#9e9789] mb-2">{course.instructor || 'Instructor'}</p>
                      <div className="flex items-center gap-1 mb-2">
                        <span className="font-bold text-sm md:text-base text-[#1a1208]">{course.rating}</span>
                        <div className="flex gap-0.5">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <Star key={i} size={12} className="text-[#f9c97a]" fill={i < Math.floor(course.rating) ? 'currentColor' : 'none'} />
                          ))}
                        </div>
                        <span className="text-xs md:text-sm text-[#9e9789]">({formatNumber(course.reviews)})</span>
                      </div>
                      <p className="text-base md:text-lg font-bold text-[#1a1208]" style={{ fontFamily: "'Playfair Display', serif" }}>${course.price}</p>
                      {course.bestseller && <span className="inline-block bg-[#f9c97a] text-[#7a4a00] font-bold px-2 py-1 rounded text-xs mt-2">Bestseller</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#1a1208] text-[#9e8e7a] py-8 md:py-12 w-full border-t border-[#2d2416]">
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-10">
            {/* Logo + address/phone/email — same brand mark as before, now
                pulled from Super Admin → Settings when one has been uploaded,
                falling back to the original text wordmark otherwise. */}
            <div>
              <button onClick={() => handleNavigate('/')}
                className="cursor-pointer hover:opacity-80 transition bg-transparent border-none p-0 block mb-4">
                {!logoLoaded ? (
                  <span className="inline-block h-16 md:h-20 w-24" aria-hidden="true" />
                ) : footerLogoUrl ? (
                  <img src={footerLogoUrl} alt="Logo" className="h-16 md:h-20 w-auto object-contain" />
                ) : (
                  <span className="text-xl md:text-2xl font-extrabold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                    Ler<span className="text-[#f9c97a]">ni</span>
                  </span>
                )}
              </button>
              <div className="text-xs md:text-sm space-y-2 leading-relaxed">
                <p className="flex items-start gap-2"><span aria-hidden="true">📍</span><span>Motiviam Pvt Ltd Building Opposite Attock Petrol Pump Adjacent Baluchistan Marble Ghazikot Mansehra</span></p>
                <p className="flex items-center gap-2">
                  <span aria-hidden="true">📞</span>
                  <a href="tel:03446199711" className="hover:text-white transition">03446199711</a>
                </p>
                <p className="flex items-center gap-2">
                  <span aria-hidden="true">✉️</span>
                  <a href="mailto:motiviampvtltd@gmail.com" className="hover:text-white transition">motiviampvtltd@gmail.com</a>
                </p>
              </div>
            </div>

            {/* FAQ-style accordion — About / Policies / Contact Us. Chevron
                points down while closed, up while open. */}
            <div>
              {[
                { key: 'about',    label: 'About',      rows: [{ label: 'About Page', path: '/about' }] },
                { key: 'policies', label: 'Policies',    rows: [{ label: '1. Return Policy', path: '/return-policy' }, { label: '2. Privacy Policy', path: '/privacy-policy' }] },
                { key: 'contact',  label: 'Contact Us',  rows: [{ label: 'Contact Us', path: '/contact-us' }] },
              ].map((tab) => {
                const isOpen = openFooterTab === tab.key;
                return (
                  <div key={tab.key} className="border-b border-[#2d2416]">
                    <button
                      onClick={() => setOpenFooterTab(isOpen ? null : tab.key)}
                      className="w-full flex items-center justify-between py-3 bg-transparent border-none cursor-pointer text-left"
                    >
                      <span className="font-bold text-[#f9c97a] text-xs md:text-sm uppercase tracking-wide">{tab.label}</span>
                      <ChevronDown size={16} className={`text-[#9e8e7a] transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {isOpen && (
                      <ul className="pb-3 space-y-2 text-xs md:text-sm">
                        {tab.rows.map((row) => (
                          <li key={row.path}>
                            <button onClick={() => handleNavigate(row.path)} className="hover:text-white transition bg-transparent border-none cursor-pointer text-[#9e8e7a] p-0 text-left">
                              {row.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Newsletter — outside the accordion tabs */}
            <div>
              <h3 className="font-bold text-[#f9c97a] mb-3 text-xs md:text-sm uppercase tracking-wide">Newsletter</h3>
              <p className="text-xs md:text-sm mb-3">Get news and updates in your inbox.</p>
              <form onSubmit={handleNewsletterSubmit} className="flex gap-2">
                <input
                  type="email"
                  required
                  value={newsletterEmail}
                  onChange={(e) => { setNewsletterEmail(e.target.value); if (newsletterStatus !== 'sending') setNewsletterStatus('idle'); }}
                  placeholder="you@example.com"
                  className="flex-1 min-w-0 bg-[#241c10] border border-[#2d2416] rounded-lg px-3 py-2 text-xs md:text-sm text-white placeholder-[#6b5e4e] focus:outline-none focus:ring-2 focus:ring-[#e8540a]"
                />
                <button
                  type="submit"
                  disabled={newsletterStatus === 'sending'}
                  className="flex-shrink-0 bg-[#e8540a] hover:bg-[#c94708] disabled:opacity-60 text-white text-xs md:text-sm font-semibold px-4 py-2 rounded-lg transition border-none cursor-pointer"
                >
                  {newsletterStatus === 'sending' ? '...' : 'Send'}
                </button>
              </form>
              {newsletterStatus === 'sent' && <p className="text-xs text-emerald-400 mt-2">✓ Subscribed — thanks!</p>}
              {newsletterStatus === 'error' && <p className="text-xs text-red-400 mt-2">Something went wrong — try again.</p>}
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center pt-6 md:pt-8 border-t border-[#2d2416] gap-3">
            <button onClick={() => handleNavigate('/')}
              className="text-xl md:text-2xl font-extrabold text-white cursor-pointer hover:opacity-80 transition bg-transparent border-none p-0"
              style={{ fontFamily: "'Playfair Display', serif" }}>
              {!logoLoaded ? <span className="inline-block h-12 md:h-14 w-20" aria-hidden="true" /> : footerLogoUrl ? <img src={footerLogoUrl} alt="Logo" className="h-12 md:h-14 w-auto object-contain" /> : <>Ler<span className="text-[#f9c97a]">ni</span></>}
            </button>
            <p className="text-xs md:text-sm text-[#6b5e4e]">© {new Date().getFullYear()} Motiviam Pvt Ltd. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* STICKY BOTTOM BAR — MOBILE */}
      <div className={`fixed bottom-0 left-0 right-0 lg:hidden bg-white border-t-2 border-[#ece6dd] p-3 md:p-4 z-50 items-center w-full shadow-2xl ${bundlesInView ? 'hidden' : 'flex'}`}>
        <button
          onClick={handleEnrollClick}
          style={{
            background: 'linear-gradient(135deg, #FF5A00 0%, #FF6A00 100%)',
            boxShadow: '0 8px 24px rgba(255, 90, 0, 0.25)',
            fontFamily: "'Inter', 'SF Pro Display', 'Poppins', sans-serif",
            fontWeight: 800,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            cursor: 'pointer',
            width: '100%',
          }}
          className="text-white py-2.5 md:py-3 rounded-xl transition text-sm md:text-base whitespace-nowrap"
        >
          {discountPct ? (
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.25rem', flexWrap: 'nowrap' }}>
              <span style={{ color: '#FFFFFF' }}>Enroll Now In {priceLabel}</span>
              <span style={{ color: '#FFFFFF', margin: '0 2px' }}> • </span>
              <span style={{ color: '#000000' }}>{discountPct}% OFF</span>
            </span>
          ) : (
            <span style={{ color: '#FFFFFF' }}>Enroll Now In {priceLabel}</span>
          )}
        </button>
      </div>

      <div className="h-16 md:h-20 lg:h-0 bg-[#1a1208]" />

      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Playfair+Display:wght@700;800;900&display=swap');

        .lerni-prose { line-height: 1.8; }
        .lerni-prose p { margin: 0.85rem 0; }
        .lerni-prose ul { list-style-type: disc; padding-left: 1.5rem; margin: 0.75rem 0; }
        .lerni-prose ol { list-style-type: decimal; padding-left: 1.5rem; margin: 0.75rem 0; }
        .lerni-prose li { margin: 0.35rem 0; line-height: 1.7; }
        .lerni-prose strong, .lerni-prose b { font-weight: 700; color: #1a1208; }
        .lerni-prose em, .lerni-prose i { font-style: italic; }
        .lerni-prose u { text-decoration: underline; }
        .lerni-prose h1 { font-family: 'Playfair Display', serif; font-size: 1.75rem; font-weight: 800; margin: 1.75rem 0 0.75rem; color: #1a1208; line-height: 1.2; }
        .lerni-prose h2 { font-family: 'Playfair Display', serif; font-size: 1.4rem; font-weight: 700; margin: 1.5rem 0 0.65rem; color: #1a1208; line-height: 1.25; }
        .lerni-prose h3 { font-family: 'Playfair Display', serif; font-size: 1.15rem; font-weight: 700; margin: 1.25rem 0 0.5rem; color: #1a1208; }
        .lerni-prose h4, .lerni-prose h5, .lerni-prose h6 { font-family: 'Playfair Display', serif; font-weight: 700; margin: 1rem 0 0.5rem; color: #1a1208; }
        .lerni-prose a { color: #e8540a; text-decoration: underline; }
        .lerni-prose a:hover { color: #c94708; }
        .lerni-prose blockquote { border-left: 3px solid #e8540a; padding-left: 1rem; margin: 1rem 0; color: #6b5e4e; font-style: italic; }
        .lerni-prose code { background: #f0ebe3; color: #1a1208; padding: 0.1em 0.35em; border-radius: 4px; font-size: 0.88em; }
        .lerni-prose hr { border: none; border-top: 1px solid #ece6dd; margin: 1.5rem 0; }
      `}</style>
    </div>
  );
}